<template>
  <v-container grid-list-md text-xs-center fluid class="one-dashboard">
    <v-layout row wrap>
      <v-flex xs12 sm12 md2 lg2>
        <template v-for="(card, i) in cards1">
          <!-- <v-card class="icon-card" :key="i+'icon'" >
              <v-icon>{{card.icon}}</v-icon>
          </v-card> -->
          <v-card :key="i" style="font-size: 12px; margin-bottom: 8px; font-weight: bolder;">
            <v-card-title class="primary white--text subheading">
              <h3 class="font-weight-light">{{$t(card.title)}}</h3>
              <v-spacer />
              <a @click.stop="openFirstDialog(card.title)">
                <!-- View {{card.title}} Details -> -->
                <v-icon right dark>remove_red_eye</v-icon>
              </a>
            </v-card-title>
            <template v-if="('amount' in card) || ('value' in card)">
              <v-card-text class="text">
                <v-card-actions class="primary--text font-weight-bold">
                  {{$t("Invoices")}}
                  <v-spacer></v-spacer>
                  <span v-if="'amount' in card">{{$t("Amount")}}</span>
                  <span v-else>{{card.value}}</span>
                </v-card-actions>
                <v-card-actions class="primary--text font-weight-bold" style="margin-top: -7px;" v-if="'amount' in card">
                  {{card.value}}
                  <v-spacer></v-spacer>
                  <span v-if="'amount' in card">{{card.amount || 0 | amount}} </span>
                </v-card-actions>
              </v-card-text>
            </template>
            <v-card-text class="text" v-if="('sellerCount' in card) || ('buyerCount' in card)">
              <v-card-actions class="primary--text font-weight-bold">
                {{$t("Buyer")}}
                <v-spacer />{{$t("Seller")}}
              </v-card-actions>
              <v-card-actions class="primary--text font-weight-bold" style="margin-top: -9px;">
                <span>{{card.buyerCount}}</span>
                <v-spacer />
                <span>{{card.sellerCount}}</span>
              </v-card-actions>
            </v-card-text>
            <v-card-text class="text" v-if="('measure' in card) || ('aggregate' in card)">
              <v-card-actions class="primary--text font-weight-bold">
                {{$t("Quantity")}}
                <v-spacer />{{$t("Amount")}}
              </v-card-actions>
              <v-card-actions class="primary--text font-weight-bold">
                <span>{{card.measure}}</span>
                <v-spacer />
                <span>{{card.aggregate || 0 | amount}} </span>
              </v-card-actions>
            </v-card-text>
            <!-- <a @click.stop="openFirstDialog(card.title)">
              View {{card.title}} Details ->
            </a>-->
          </v-card>
        </template>
      </v-flex>
      <v-flex xs12 sm12 md8>
        <!-- <v-card>
          <v-tabs
              v-model="tab"
              centered
              icons-and-text
            >
              <v-tabs-slider></v-tabs-slider>

              <v-tab href="#tab-1">
                Trade
                <v-icon>import_export</v-icon>
              </v-tab>

              <v-tab href="#tab-2">
                Volume
                <v-icon>widgets</v-icon>
              </v-tab>

              <v-tab href="#tab-3">
                Product
                <v-icon>redeem</v-icon>
              </v-tab>
            </v-tabs>

            <v-tabs-items v-model="tab">
              <v-tab-item
                v-for="i in 3"
                :key="i"
                :value="'tab-' + i"
              >
                <v-card flat>
                  <v-card-text><apexchart type="bar" height="555" :options="options" :series="series"></apexchart></v-card-text>
                </v-card>
              </v-tab-item>
            </v-tabs-items>
        </v-card>-->

      <v-layout row wrap style="display: none;"  id="dashboard-filters">
        <v-flex xs12 md4>
          <v-select
            class="select-firm-dashboard"
            dense
            :items="firmsByBrand"
            :label="$t('Select Firm')"
            v-model="selectedFirm"
            clearable
          ></v-select>
        </v-flex>

        <v-flex xs12 md4>
          <v-menu
            :close-on-content-click="false"
            v-model="datepickerFrom"
            :nudge-right="40"
            class="ist-datepicker-dashboard"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            min-width="290px"
            clearable
          >
            <v-text-field
              slot="activator"
              v-model="fromDate"
              :label="$t('From Date')"
              prepend-icon="event"
              readonly
              clearable
            ></v-text-field>
            <v-date-picker v-model="fromDate" @input="datepickerFrom = false"></v-date-picker>
          </v-menu>
        </v-flex>
        <v-flex xs12 md4>
          <v-menu
            :close-on-content-click="false"
            v-model="datepickerTo"
            :nudge-right="40"
            lazy
            transition="scale-transition"
            class="ist-datepicker-dashboard"
            offset-y
            full-width
            min-width="290px"
            clearable
          >
            <v-text-field
              slot="activator"
              v-model="toDate"
              :label="$t('To Date')"
              prepend-icon="event"
              readonly
              clearable
            ></v-text-field>
            <v-date-picker v-model="toDate" @input="datepickerTo = false"></v-date-picker>
          </v-menu>
        </v-flex>
        </v-layout>

        <v-tabs color="primary" dark icons v-model="tab">
          <v-tabs-slider color="yellow"></v-tabs-slider>
          <v-tab :key="'tab-1'" href="#tab-1">
            {{$t("Trade")}}
            <v-icon>swap_vert</v-icon>
          </v-tab>

          <v-tab :key="'tab-2'" href="#tab-2">
            {{$t("Volume")}}
            <v-icon>swap_horiz</v-icon>
          </v-tab>

          <v-tab :key="'tab-3'" href="#tab-3">
            {{$t("Product")}}
            <v-icon>category</v-icon>
          </v-tab>

          <v-tab :key="'tab-4'" href="#tab-4">
            {{$t("Daily")}}
            <v-icon>category</v-icon>
          </v-tab>

          <v-switch
            v-model="isFilter"
            color="white"
            class="filter-switch"
            :label="$t(`${isFilter ? 'Hide Filter' : 'Show Filter'}`)"
          ></v-switch>

          <v-tabs-items>
            <v-tab-item :key="'tab1'" :value="'tab-1'">
              <v-card flat>
                <v-card-text>
                  <apexchart type="bar" height="550" :options="tradeOptions" :series="tradeData"></apexchart>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item :key="'tab2'" :value="'tab-2'">
              <v-card flat>
                <v-card-text>
                  <apexchart type="bar" height="550" :options="volumeOptions" :series="volumeData"></apexchart>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item :key="'tab4'" :value="'tab-4'">
              <v-card flat>
                <v-card-text>
                  <apexchart type="bar" height="550" :options="volumeOptionsDaily" :series="volumeDataDaily"></apexchart>
                </v-card-text>
              </v-card>
            </v-tab-item>
          </v-tabs-items>
        </v-tabs>
      </v-flex>

      <!-- Section 3 -->
      <v-flex xs12 sm12 md2 lg2 style="cursor: pointer">
        <!-- Quick Invoice -->
        <v-card class="sec3-card">
          <router-link to="/quick-invoice" style="text-decoration: none;">
            <v-card-text class="pa-2">
              <v-icon color="primary">note_alt</v-icon>  {{$t("Invoicing")}}
            </v-card-text>
          </router-link>
        </v-card>
        <!-- Receipts/Payments -->
        <v-card class="sec3-card">
          <router-link to="/customer-payments/null" style="text-decoration: none;">
            <v-card-text class="pa-2">
              <v-icon color="primary">currency_rupee</v-icon>  {{$t("Receipt/Payments")}}
            </v-card-text>
          </router-link>
        </v-card>
        
        <!-- Manage Estimate -->
        <v-card class="sec3-card">
          <router-link v-if="$route.path!='/recordEstimate'" to="/recordEstimate" style="text-decoration: none;">
          <!-- <router-link to="/quick-invoice" style="text-decoration: none;"> -->
            <v-card-text class="pa-2">
              <v-icon color="primary">list_alt </v-icon>  {{$t("Estimate/Challans")}}
            </v-card-text>
          </router-link>
        </v-card>
        
        <!-- Manage Order -->
        <v-card class="sec3-card">
          <router-link v-if="$route.path!='/recordOrder'" to="/recordOrder" style="text-decoration: none;">
            <v-card-text class="pa-2">
              <v-icon color="primary"> content_paste </v-icon>  {{$t("Manage Orders")}}
            </v-card-text>
          </router-link>
        </v-card>
       
        <!-- Portfolio Management-->
        <v-card class="sec3-card">
          <router-link to="/portfolio-management" style="text-decoration: none;">
            <v-card-text class="pa-2">
              <v-icon color="primary">fact_check</v-icon>  {{$t("Manage Portfolio")}}
            </v-card-text>
          </router-link>
        </v-card>
        
        <!-- lead Register -->
        <!-- <v-card class="sec3-card">
          <router-link  to="/lead-record" style="text-decoration: none;">
            <v-card-text class="pa-2">
              <v-icon color="primary"> repeat_on </v-icon> {{$t("Manage Leads")}}
            </v-card-text>
          </router-link>
        </v-card> -->
        
        <!-- firm Account -->
        <v-card class="sec3-card" @click="Sec3DetailsDialog=true; Sec3Type='firm'">
          <v-card-text class="pa-2">
            <v-icon color="primary">menu_book</v-icon>  {{$t("Firms")}}
          </v-card-text>
        </v-card>
        
        <!-- Bank Account -->
        <v-card class="sec3-card" @click="Sec3DetailsDialog=true; Sec3Type='bank'">
          <v-card-text class="pa-2">
            <v-icon color="primary">account_box</v-icon>  {{$t("Bank Accounts")}} 
          </v-card-text>
        </v-card>

        <!-- cash Account -->
        <v-card class="sec3-card" @click="Sec3DetailsDialog=true; Sec3Type='cash'">
          <v-card-text class="pa-2">
            <v-icon color="primary">assignment</v-icon>  {{$t("Cash Book")}}
          </v-card-text>
        </v-card>

        <!-- cash Account -->
        <v-card class="sec3-card">
          <router-link to="/daily-transaction-book" style="text-decoration: none;">
            <v-card-text class="pa-2">
              <v-icon color="primary">analytics</v-icon>  {{$t("Day Book")}}
            </v-card-text>
          </router-link>
        </v-card>

        <!-- Cash Account -->
        <!-- <v-card class="sec3-card">
          <router-link :to="{ name: 'CashAccount'}" style="text-decoration: none;">
            <v-card-text class="pa-2">
              <v-icon color="primary">remove_red_eye</v-icon>Cash Accounts
            </v-card-text>
          </router-link>
        </v-card> -->
        
        <!-- Financial Books -->
        <v-card class="sec3-card" @click="bookExpansion = !bookExpansion">
          <v-card-text class="pa-2">
            <v-icon v-if="!bookExpansion" color="primary">expand_more</v-icon>
            <v-icon v-if="bookExpansion" color="primary">expand_less</v-icon>  {{$t("Financial Reports")}}
          </v-card-text>
        </v-card>
        <template v-if="bookExpansion">
          <v-card class="sec3-card">
            <router-link :to="{ name: 'Bsheet'}" style="text-decoration: none;">
              <v-card-text class="pa-2" style="font-size: 12px;">
                <b class="font-weight-light"> {{$t("View Balance Sheet")}}</b>
              </v-card-text>
            </router-link>
          </v-card>
          <v-card class="sec3-card">
            <router-link :to="{ name: 'Tradingaccount'}" style="text-decoration: none;">
              <v-card-text class="pa-2" style="font-size: 12px;">
                <b class="font-weight-light"> {{$t("View Trading Account")}}</b>
              </v-card-text>
            </router-link>
          </v-card>
          <v-card class="sec3-card">
            <router-link :to="{ name: 'Profitandloss'}" style="text-decoration: none;">
              <v-card-text class="pa-2" style="font-size: 12px;">
                <b class="font-weight-light"> {{$t("View Profit and Loss Account")}}</b>
              </v-card-text>
            </router-link>
          </v-card>
          <v-card class="sec3-card">
            <router-link :to="{ name: 'Proprietor'}" style="text-decoration: none;">
              <v-card-text class="pa-2" style="font-size: 12px;">
                <b class="font-weight-light"> {{$t("View Prop Capital Account")}}</b>
              </v-card-text>
            </router-link>
          </v-card>
          <v-card class="sec3-card">
            <router-link :to="{ name: 'TrailBalanceAccounts'}" style="text-decoration: none;">
              <v-card-text class="pa-2" style="font-size: 12px;">
                <b class="font-weight-light"> {{$t("View Trail Balance")}}</b>
              </v-card-text>
            </router-link>
          </v-card>
        </template>
        
        <!-- GST Reports -->
        <v-card class="sec3-card" @click="gstrExpansion = !gstrExpansion">
          <v-card-text class="pa-2">
            <v-icon v-if="!gstrExpansion" color="primary">expand_more</v-icon>
            <v-icon v-if="gstrExpansion" color="primary">expand_less</v-icon>  {{$t("GST Reports")}}
          </v-card-text>
        </v-card>
        <template v-if="gstrExpansion">
          <v-card class="sec3-card">
            <router-link :to="{ name: 'GST1Reports'}" style="text-decoration: none;">
              <v-card-text class="pa-2" style="font-size: 12px;">
                <a class="font-weight-light"> {{$t("GSTR-1")}}</a>
              </v-card-text>
            </router-link>
          </v-card>
          <v-card class="sec3-card">
            <router-link :to="{ name: 'GST3Reports'}" style="text-decoration: none;">
              <v-card-text class="pa-2" style="font-size: 12px;">
                <a class="font-weight-light"> {{$t("GSTR-3B")}}</a>
              </v-card-text>
            </router-link>
          </v-card>
          <v-card class="sec3-card">
            <router-link :to="{ name: 'GSTAccounts'}" style="text-decoration: none;">
              <v-card-text class="pa-2" style="font-size: 12px;">
                <a class="font-weight-light"> {{$t("GST Accounts")}}</a>
              </v-card-text>
            </router-link>
          </v-card>
        </template>


        <!-- Other Account -->
        <v-card class="sec3-card" @click="otherAcctExpansion = !otherAcctExpansion">
          <v-card-text class="pa-2">
            <v-icon v-if="!otherAcctExpansion" color="primary">expand_more</v-icon>
            <v-icon v-if="otherAcctExpansion" color="primary">expand_less</v-icon>  {{$t("Other Accounts")}}
          </v-card-text>
        </v-card>
        <template v-if="otherAcctExpansion">
          <v-card class="sec3-card">
            <router-link to="/product-report" style="text-decoration: none;">
              <v-card-text class="pa-2 font-weight-light"  style="font-size: 12px;">
                {{$t("Product Report")}}
              </v-card-text>
            </router-link>
           </v-card>
          <v-card class="sec3-card">
            <v-card-text
              class="pa-2 font-weight-light"
              @click="Sec3DetailsDialog=true; Sec3Type='expense'"
              style="font-size: 13px;"
            > {{$t("Expense Accounts")}}</v-card-text>
          </v-card>
          <v-card class="sec3-card">
            <v-card-text
              class="pa-2 font-weight-light"
              @click="Sec3DetailsDialog=true; Sec3Type='income'"
              style="font-size: 13px;"
            > {{$t("INCOME ACCOUNTS")}}</v-card-text>
          </v-card>
          <v-card class="sec3-card">
            <v-card-text
              class="pa-2 font-weight-light"
              @click="Sec3DetailsDialog=true; Sec3Type='asset'"
              style="font-size: 13px;"
            > {{$t("ASSET ACCOUNTS")}}</v-card-text>
          </v-card>
          <v-card class="sec3-card">
            <v-card-text
              class="pa-2 font-weight-light"
              @click="Sec3DetailsDialog=true; Sec3Type='salary'"
              style="font-size: 13px;"
            > {{$t("Salary Accounts")}}</v-card-text>
          </v-card>
          <!-- Debit Note -->
          <v-card class="sec3-card" @click.stop="openFirstDialog('Credit Note')">
            <v-card-text class="pa-2 font-weight-light" style="font-size: 13px;">
              {{$t("Credit Note")}}
            </v-card-text>
          </v-card>
          
          <!-- Credit Note-->
          <v-card class="sec3-card" @click.stop="openFirstDialog('Debit Note')">
            <v-card-text class="pa-2 font-weight-light" style="font-size: 13px;">
              {{$t("Debit Note")}}
            </v-card-text>
          </v-card>
          
          <!-- ITC -->
          <v-card class="sec3-card">
            <router-link :to="{ name: 'IST'}" style="text-decoration: none;">
              <v-card-text class="pa-2 font-weight-light" style="font-size: 13px;">
                {{$t("ITC")}}
              </v-card-text>
            </router-link>
          </v-card>
        </template>

        <!-- Godawn -->
        <v-card class="sec3-card">
          <router-link v-if="$route.path!='/godawn'" to="/godawn" style="text-decoration: none;">
            <v-card-text class="pa-2">
              <v-icon color="primary"> store </v-icon>  {{$t("Godowns")}}
            </v-card-text>
          </router-link>
        </v-card>

        <!-- Receipt Collection -->
        <!-- <v-card class="sec3-card">
          <router-link v-if="$route.path!='/godawn'" to="/godawn" style="text-decoration: none;">
            <v-card-text class="pa-2">
              <v-icon color="primary"> store </v-icon>  {{$t("Godowns")}}
            </v-card-text>
          </router-link>
        </v-card> -->
        
        <!-- Receipt Register -->
        <!-- <v-card class="sec3-card">
          <router-link  to="/receipt-register" style="text-decoration: none;">
            <v-card-text class="pa-2">
              <v-icon color="primary"> store </v-icon>  Receipt Register
            </v-card-text>
          </router-link>
        </v-card> -->
        <!-- end of Receipt Register -->

        <!-- Deposits -->
        <!-- <v-card class="sec3-card" @click="depositExpansion = !depositExpansion">
          <v-card-text class="pa-2">
            <v-icon v-if="!depositExpansion" color="primary">expand_more</v-icon>
            <v-icon v-if="depositExpansion" color="primary">expand_less</v-icon>Receipts/Payments
          </v-card-text>
        </v-card>
        <template v-if="depositExpansion">
          <v-card class="sec3-card">
            <v-card-text class="pa-2" style="font-size: 13px;">Receipts</v-card-text>
          </v-card>
          <v-card class="sec3-card">
            <v-card-text class="pa-2" style="font-size: 13px;">Payments</v-card-text>
          </v-card>
        </template> -->

      </v-flex>

      <!-- Top Customers / Products -->
      <v-flex xs12 sm12 md6>
        <v-card>
          <v-card-text>
            <v-toolbar dark color="primary">
              <v-toolbar-title class="title font-weight-light"> {{$t('Top Selling Products')}}</v-toolbar-title>
            </v-toolbar>
            <v-data-table :headers="getTranslatedHeaders(topProdHead)"  :items="getTopProducts" class="elevation-1">
              <template slot="items" slot-scope="props">
                <td class="text-xs-left">
                  <b class="font-weight-bold primary--text">{{props.item['name']}}</b>
                </td>
                <td class="text-xs-left">
                  <b>{{props.item['unit']}}</b>
                </td>
                <td class="text-xs-left">
                  <b>{{props.item['saleQuantity']}}</b>
                </td>
                <td class="text-xs-left">
                  <b v-if="props.item['updatedSellingDate']">{{dayDiff(props.item['updatedSellingDate'])}}</b>
                </td>
                <!-- <td class="text-xs-left"><b>{{props.item['basicPrice']}}</b></td> -->
                <!-- <td class="text-xs-left">
                  <b>{{props.item['basicPrice'] && props.item['gstValue'] ? (Number.parseFloat(props.item['basicPrice']) + Number.parseFloat(props.item['gstValue'])).toFixed(2) : 0}}</b>
                </td> -->
              </template>
              <template slot="no-data">{{$t("No Items")}}</template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs12 sm12 md6>
        <v-card>
          <v-card-text>
            <v-toolbar dark color="primary">
              <v-toolbar-title class="title font-weight-light"> {{$t("Top Billing Customer")}}</v-toolbar-title>
              <v-spacer />
                <v-select 
                  clearable
                  v-model="topCustomerFilter" 
                  :items="['Customers','Suppliers','All']" 
                  label="Filter">
                </v-select>
            </v-toolbar>
            <v-data-table
              :headers="getTranslatedHeaders(topCustHead)"
              :items="topCustomers"
              class="elevation-1 dashboardHead"
            >
              <template slot="items" slot-scope="props">
                <td class="text-xs-left">
                  <b>
                    <router-link
                      style="text-decoration: none"
                      :to="'/buyers/' + props.item['.key']"
                    >
                    {{props.item['name']}}
                    </router-link>
                  </b>
                </td>
                <td class="text-xs-left success--text">
                  <b>{{props.item['totalAmount'] || 0 | amount }}</b>
                </td>
                <td class="text-xs-left primary--text">
                  <b>{{props.item['paidAmount'] || 0 | amount}}</b>
                </td>
                <td class="text-xs-left error--text">
                  <b>{{props.item['remainingAmount'] || 0 | amount}}</b>
                </td>
              </template>
              <template slot="no-data">{{$t("No Items")}}</template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>

    <v-dialog
      v-model="Sec3DetailsDialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card v-if="Sec3Type =='firm'" class="one-dashboard">
        <!-- Firms -->
        <v-card-title primary title class="primary white--text">
          <h2>FIRMS</h2>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="Sec3DetailsDialog = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>

        <v-layout row wrap>
          <v-flex xs12 md12>
            <v-card-text>
              <v-layout row wrap>
                <v-flex
                  xs12
                  md3
                  sm3
                  v-for="firm in getFirmSorted"
                  :key="firm['.key']"
                  style="padding:15px"
                >
                  <v-card class="icon-card">
                    <v-icon style="padding: 12px 18px;">table_chart</v-icon>
                  </v-card>
                  <v-card class="sec1-card" :key="firm['.key']+'F'">
                    <v-card-title primary-title class="subheading font-weight-bold" style="font-size: 20px;">
                      <v-spacer />
                      {{firm.name}}
                    </v-card-title>
                    <!-- <v-card-actions>
                      <v-spacer></v-spacer>
                      <h4 class="subheading primary--text font-weight-light">Balance</h4>
                      <v-spacer></v-spacer>
                    </v-card-actions>
                    <v-card-actions style="margin-top: -14px;">
                      <v-spacer></v-spacer>
                      <span>
                        <h5 class="subheading font-weight-bold">
                          {{getFirmBalance(firm,'combined') | amount}}/-
                        </h5>
                      </span>
                      <v-spacer></v-spacer>
                    </v-card-actions>
                    <v-card-actions>
                      <b class="subheading primary--text font-weight-light">Cash In Hand</b>
                      <v-spacer></v-spacer>
                      <b class="subheading primary--text font-weight-light">Bank Balance</b>
                    </v-card-actions>
                    <v-card-actions style="margin-top: -14px;">
                      {{firm.amount | amount}}/-
                      <v-spacer></v-spacer>
                      {{getFirmBalance(firm,'bank')| amount}}/-
                    </v-card-actions> -->
                    <v-card-actions>
                      <v-spacer/>                    
                        <router-link 
                          style="text-decoration: none;"
                          :to="{ name: 'FirmStatements', params: {firmId: firm['.key']}}">
                          <v-btn outline class="primary--text font-weight-bold"> 
                            <v-icon left style="text-decoration: none;"> remove_red_eye </v-icon>  
                            Statement
                          </v-btn>
                        </router-link>
                      <v-spacer/> 
                    </v-card-actions>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-flex>
        </v-layout>
      </v-card>


      <!-- Cash Dialog -->
      <v-card v-if="Sec3Type =='cash'" class="one-dashboard">
        <v-card-title primary title class="primary white--text">
          <h2>CASH ACCOUNTS</h2>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="Sec3DetailsDialog = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>

        <v-layout row wrap>
          <v-flex xs12 md12>
            <v-card-text>
              <v-layout row wrap>
                <v-flex
                  xs12
                  md3
                  sm3
                  v-for="firm in getFirmSorted"
                  :key="firm['.key']"
                  style="padding:15px"
                >
                  <v-card class="icon-card">
                    <v-icon style="padding: 12px 18px;">table_chart</v-icon>
                  </v-card>
                  <v-card class="sec1-card" :key="firm['.key']+'F'">
                    <v-card-title primary-title class="subheading font-weight-bold" style="font-size: 30px;">
                      <v-spacer />
                      {{firm.name}}
                    </v-card-title>
                    <!-- <v-card-actions>
                      <v-spacer></v-spacer>
                      <b class="subheading primary--text font-weight-light">Cash In Hand</b>
                      <v-spacer></v-spacer>
                    </v-card-actions>
                    <v-card-actions style="margin-top: -15px;">
                      <v-spacer></v-spacer>
                      {{firm.amount | amount}}/-
                      <v-spacer></v-spacer>
                    </v-card-actions> -->
                    <v-card-actions>
                      <v-spacer/>
                      <router-link 
                        style="text-decoration: none;"
                        :to="{ name: 'CashStatements', params: {firmId: firm['.key']}}">
                        <v-btn outline class="primary--text font-weight-bold">
                          <v-icon left class="primary--text">
                            remove_red_eye
                          </v-icon>
                          Statement
                        </v-btn>
                      </router-link>
                      <v-spacer/>
                    </v-card-actions>
                      <v-dialog
                        v-model="firmDialog"
                        persistent
                        fullscreen
                        hide-overlay
                        transition="dialog-bottom-transition"
                      >
                        <v-card>
                          <v-flex v-for="firm in getFirmSorted" :key="firm['.key']">
                            <template v-if="firm.name && firm.name==currentFirm">
                              <v-card primary title class="primary white--text">
                                <v-card-title primary-title row wrap>
                                    <b class="title font-weight-light">Cash Book</b>
                                    <v-spacer/>
                                  <!-- <div class="title"> -->
                                    <b class="title font-weight-light"> {{firm.name}}</b>
                                    <v-spacer/>
                                    <b class="title font-weight-light"> {{firm.proprietor}}</b>
                                    <v-spacer/>
                                    Available Cash Balance:-
                                    <b class="title font-weight-light"> {{(firm.amount).toFixed(2)}}</b>
                                    <v-spacer/>
                                  <!-- </div> -->
                                  <v-spacer />
                                  <v-btn icon dark @click="firmDialog = false">
                                    <v-icon>close</v-icon>
                                  </v-btn>
                                </v-card-title>
                              </v-card>
                            </template>
                          </v-flex>

          <v-card-text>
            <v-layout row wrap style="padding: 10px 50px 5px 21px;">
              <!-- <v-flex xs12 md3>
                <v-select
                  class="select-firm"
                  dense
                  :items="firmsByBrand"
                  label="Select Firm"
                  v-model="selectedFirm"
                  clearable
                ></v-select>
              </v-flex> -->
              

              <v-flex xs12 md3>
                <v-menu
                  :close-on-content-click="false"
                  v-model="datepickerFrom3"
                  :nudge-right="40"
                  class="ist-datepicker-dashboard"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  clearable
                >
                  <v-text-field
                    slot="activator"
                    v-model="fromDate"
                    label="From Date"
                    prepend-icon="event"
                    readonly
                    clearable
                  ></v-text-field>
                  <v-date-picker v-model="fromDate" @input="datepickerFrom3 = false"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex xs12 md3>
                <v-menu
                  :close-on-content-click="false"
                  v-model="datepickerTo3"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  class="ist-datepicker-dashboard"
                  offset-y
                  full-width
                  min-width="290px"
                  clearable
                >
                  <v-text-field
                    slot="activator"
                    v-model="toDate"
                    label="To Date"
                    prepend-icon="event"
                    readonly
                    clearable
                  ></v-text-field>
                  <v-date-picker v-model="toDate" @input="datepickerTo3 = false"></v-date-picker>
                </v-menu>
              </v-flex>
            </v-layout>
                            <v-data-table
                              :headers="getTranslatedHeaders(firmHeader)"
                              :items="getCashInvoices"
                              class="elevation-1 dashboardHead"
                            >
                              <template slot="items" slot-scope="props">
                                <!-- <td>{{new Date(props.item.date).toLocaleDateString('en-GB')}}</td> -->
                                <td
                                  class="primary--text font-weight-bold"
                                  v-html="renderDate(props.item.date)"
                                ></td>
                                <td>{{ getFirmName(props.item.firm) }}</td>
                                <td>
                                  <b
                                    class="primary--text font-weight-bold"
                                  >{{ getCurrentUserName(props.item.buyerId)}}</b>
                                </td>
                                <td>{{ props.item['.key']}}</td>
                                <template v-if="!props.item.isCredited && props.item.buyerId">
                                  <td></td>
                                  <td>
                                    <!-- <h3 class="green--text text--darken-4">{{ Number.parseFloat(props.item.paidAmount) || 0 | amount  }} </h3> -->
                                    <!-- <h3
                                      class="success--text text--darken-4"
                                    > {{Number.parseFloat(props.item.totalAmount) - Number.parseFloat(props.item.discountAmount || 0 ) || 0 | amount }}</h3> -->
                                    <h3 class="green--text text--darken-4">{{ (Number.parseFloat(props.item.amountFromBank) + Number.parseFloat(props.item.amountFromCash)) || 0 | amount  }} </h3>
                                  </td>
                                </template>
                                <template v-if="props.item.isCredited && props.item.buyerId">
                                  <td>
                                    <!-- <h3 class="red--text text--darken-4">{{ Number.parseFloat(props.item.paidAmount) || 0 | amount  }} </h3> -->
                                    <!-- <h3
                                      class="error--text text--darken-4"
                                    > {{Number.parseFloat(props.item.totalAmount) - Number.parseFloat(props.item.discountAmount || 0) || 0 | amount }}</h3> -->
                                    <h3 class="red--text text--darken-4">{{ (Number.parseFloat(props.item.amountFromBank) + Number.parseFloat(props.item.amountFromCash)) || 0 | amount  }} </h3>
                                  </td>
                                  <td></td>
                                </template>
                                <template v-if="!props.item.isCredited && !props.item.buyerId">
                                  <td>
                                    <!-- <h3 class="success--text text--darken-4">{{ Number.parseFloat(props.item.paidAmount)  }} </h3> -->
                                    <h3
                                      class="red--text text--darken-4"
                                    > {{Number.parseFloat(props.item.totalAmount) - Number.parseFloat(props.item.discountAmount || 0 ) || 0 | amount }}</h3>
                                  </td>
                                  <td></td>
                                </template>
                                <template v-if="props.item.isCredited && !props.item.buyerId">
                                  <td></td>
                                  <td>
                                    <!-- <h3 class="red--text text--darken-4">{{ Number.parseFloat(props.item.paidAmount)  }} </h3> -->
                                    <h3
                                      class="green--text text--darken-4"
                                    > {{Number.parseFloat(props.item.totalAmount) - Number.parseFloat(props.item.discountAmount || 0) || 0 | amount }}</h3>
                                  </td>
                                  
                                </template>
                                <td>{{ props.item.paymentType }}</td>
                                <td>{{ props.item.status }}</td>
                                <td>
                                  <b
                                    class="primary--text font-weight-bold"
                                  >{{ getVocherType(props.item)}}</b>
                                </td>
                                <td>{{ props.item.remark }}</td>
                              </template>
                              <template slot="no-data">No Items</template>
                            </v-data-table>
                          </v-card-text>
                        </v-card>
                      </v-dialog>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-flex>
        </v-layout>
      </v-card>

      <!-- Bank Dialog  -->
      <v-card v-if="Sec3Type =='bank'" class="one-dashboard">
        <v-card-title primary title class="primary white--text">
          <h2>{{$t("BANK ACCOUNTS")}}</h2>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="Sec3DetailsDialog = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-layout row wrap>
          <v-flex xs12 md12>
            <v-card-text>
              <v-layout row wrap>
                <v-flex
                  xs12
                  md3
                  sm3
                  v-for="account in getSortedBankAccounts"
                  :key="account['.key']"
                  style="padding:15px"
                >
                  <v-card class="icon-card">
                    <v-icon style="padding: 12px 18px;">account_balance_wallet</v-icon>
                  </v-card>
                  <v-card class="sec1-card" :key="account['.key']+'B'">
                    <v-card-title primary-title>
                      <v-spacer />
                      <div>
                       <h3 class="title font-weight-bold">{{account.bankName}} </h3>
                       <h5 class="font-weight-light">{{account.accountnumber}} - {{getFirmName(account.firm)}} </h5>
                      </div>
                    </v-card-title>
                    <!-- <template>
                      <v-card-text>
                        <v-card-actions>
                          <v-spacer />
                          <h3 class="font-weight-light">{{$t("Balance")}}</h3>
                          <v-spacer />
                        </v-card-actions>
                        <v-card-actions style="margin-top: -15px;">
                          <v-spacer/>
                          <span>
                            <h3 class="title font-weight-bold">
                              {{account.amount | amount}}/-
                            </h3>
                          </span>
                          <v-spacer />
                        </v-card-actions>
                      </v-card-text>
                    </template> -->
                    <v-card-actions>
                      <v-spacer />
                        <router-link 
                          style="text-decoration: none;"
                          :to="{ name: 'BankStatements', params: {bankId: account['.key']}}">
                        <v-btn outline class="primary--text font-weight-bold">
                          <v-icon left class="primary--text">
                            remove_red_eye
                          </v-icon> {{$t("Statement")}}
                        </v-btn>
                      </router-link>
                      <v-spacer />
                    </v-card-actions>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-flex>
        </v-layout>
      </v-card>
      <v-card v-if="Sec3Type =='expense'" class="one-dashboard">
        <v-card-title primary title class="primary white--text">
          <h3>{{$t("EXPENSE ACCOUNTS")}}</h3>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="Sec3DetailsDialog = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-layout row wrap>
          <v-flex xs12 md12>
            <v-card-text>
              <v-layout row wrap>
                <v-flex
                  xs12
                  md3
                  sm3
                  v-for="expense in getExpenses"
                  :key="expense['.key']"
                  style="padding:15px"
                >
                  <v-card class="icon-card">
                    <v-icon style="padding: 12px 18px;">account_balance_wallet</v-icon>
                  </v-card>
                  <v-card class="sec1-card" :key="expense['.key']+'E'">
                    <v-card-title primary-title>
                      <v-spacer />
                      <div class="title font-weight-bold">{{expense.expense}}</div>
                    </v-card-title>
                    <template>
                      <v-card-text class="text">
                        <!-- <v-card-actions>
                          Available Balance - &#8377;
                            <v-spacer></v-spacer>
                            <span>{{account.amount}}/-</span>
                        </v-card-actions>-->
                      </v-card-text>
                    </template>
                    <v-card-actions>
                      <v-spacer />
                      <v-btn outline @click="openDialog (expense['.key'])">
                        <v-icon left class="primary--text">remove_red_eye</v-icon>
                        {{$t("Statement")}}
                      </v-btn>
                      <v-spacer />
                    </v-card-actions>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-flex>
        </v-layout>
      </v-card>
      <v-card v-if="Sec3Type =='income'" class="one-dashboard">
        <v-card-title primary title class="primary white--text">
          <h3>{{$t("INCOME ACCOUNTS")}}</h3>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="Sec3DetailsDialog = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-layout row wrap>
          <v-flex xs12 md12>
            <v-card-text>
              <v-layout row wrap>
                <v-flex
                  xs12
                  md3
                  sm3
                  v-for="income in getIncomes"
                  :key="income['.key']"
                  style="padding:15px"
                >
                  <v-card class="icon-card">
                    <v-icon style="padding: 12px 18px;">account_balance_wallet</v-icon>
                  </v-card>
                  <v-card class="sec1-card" :key="income['.key']+'I'">
                    <v-card-title primary-title>
                      <v-spacer />
                      <div class="title font-weight-bold">{{income.income}}</div>
                    </v-card-title>
                    <template>
                      <v-card-text class="text">
                        <!-- <v-card-actions>
                          Available Balance - &#8377;
                            <v-spacer></v-spacer>
                            <span>{{account.amount}}/-</span>
                        </v-card-actions>-->
                      </v-card-text>
                    </template>

                    <v-card-actions>
                      <v-spacer />
                      <v-btn outline @click="openDialog1 (income['.key'])">
                        <v-icon left class="primary--text">remove_red_eye</v-icon>
                        {{$t("Statement")}}
                      </v-btn>
                      <v-spacer />
                    </v-card-actions>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-flex>
        </v-layout>
      </v-card>
      <v-card v-if="Sec3Type =='asset'" class="one-dashboard">
        <v-card-title primary title class="primary white--text">
          <h3>{{$t("ASSET ACCOUNTS")}}</h3>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="Sec3DetailsDialog = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-layout row wrap>
          <v-flex xs12 md12>
            <v-card-text>
              <v-layout row wrap>
                <v-flex
                  xs12
                  md3
                  sm3
                  v-for="asset in getAssets"
                  :key="asset['.key']"
                  style="padding:15px"
                >
                  <v-card class="icon-card">
                    <v-icon style="padding: 12px 18px;">account_balance_wallet</v-icon>
                  </v-card>
                  <v-card class="sec1-card" :key="asset['.key']+'A'">
                    <v-card-title primary-title>
                      <v-spacer />
                      <div class="title font-weight-bold">{{asset.asset}}</div>
                    </v-card-title>
                    <template>
                      <v-card-text class="text">
                        <!-- <v-card-actions>
                          Available Balance - &#8377;
                            <v-spacer></v-spacer>
                            <span>{{account.amount}}/-</span>
                        </v-card-actions>-->
                      </v-card-text>
                    </template>
                    <v-card-actions>
                      <v-spacer />
                      <v-btn outline @click="openDialog7 (asset['.key'])">
                        <v-icon left class="primary--text">remove_red_eye</v-icon>
                        {{$t("Statement")}}
                      </v-btn>
                      <v-spacer />
                    </v-card-actions>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-flex>
        </v-layout>
      </v-card>
      <v-card v-if="Sec3Type =='salary'" class="one-dashboard">
        <v-card-title primary title class="primary white--text">
          <h3>{{$t("SALARY ACCOUNTS")}}</h3>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="Sec3DetailsDialog = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-layout row wrap>
          <v-flex xs12 md12>
            <v-card-text>
              <v-layout row wrap>
                <v-flex
                  xs12
                  md3
                  sm3
                  v-for="staff in getStaffs"
                  :key="staff['.key']"
                  style="padding:15px"
                >
                  <v-card class="icon-card">
                    <v-icon style="padding: 12px 18px;">account_balance_wallet</v-icon>
                  </v-card>
                  <v-card class="sec1-card" :key="staff['.key']+'St'">
                    <v-card-title primary-title>
                      <v-spacer />
                      <div class="title">{{staff.staffName}}</div>
                    </v-card-title>
                    <template>
                      <v-card-text class="text">
                        <!-- <v-card-actions>
                          Available Balance - &#8377;
                            <v-spacer></v-spacer>
                            <span>{{account.amount}}/-</span>
                        </v-card-actions>-->
                      </v-card-text>
                    </template>
                    <v-card-actions>
                      <v-spacer />
                      <v-btn outline @click="openDialog6 (staff['.key'])">
                        <v-icon left class="primary--text">remove_red_eye</v-icon>
                        {{$t("Statement")}}
                      </v-btn>
                      <v-spacer />
                    </v-card-actions>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-flex>
        </v-layout>
      </v-card>
    </v-dialog>

    <!-- Bank Account Dialog -->
    <v-dialog
      v-model="accountDialog"
      persistent
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card>
        <!-- <v-card-title primary title class="primary white--text">
          <h2 color="primary">ACCOUNT SUMMARY</h2>
          <v-spacer/>   
          <v-btn icon dark @click="accountDialog = false">
            <v-icon>close</v-icon>
          </v-btn> 
        </v-card-title>-->

        <v-flex v-for="account in getSortedBankAccounts" :key="account['.key']" xs12 sm12 md12>
          <template v-if="account.accountnumber && account.accountnumber==currentAccountNumber">
            <v-card primary title class="primary white--text">
              <v-card-title primary-title class="title font-weight-light" row>
                {{getFirmName(account.firm)}}
                <v-spacer />
                {{account.bankName}}
                <v-spacer />
                {{account.accountHolderName}}
                <v-spacer />
                {{account.accountType}}
                <v-spacer />Available Balance : &nbsp; &#8377;
                <b>{{account.amount | amount}}/-</b>
                <v-spacer />
                <v-btn icon dark @click="accountDialog = false">
                  <v-icon>close</v-icon>
                </v-btn>
              </v-card-title>
              <!-- <v-card-text class="headline">
              Account Holder Name -<span>{{account.accountHolderName}} </span>
            </v-card-text>
            <v-card-text class="headline">
              Available Balance - <span>{{account.amount}}/- </span>
              </v-card-text>-->
            </v-card>

            <v-layout row wrap style="padding: 10px 50px 5px 21px;">
              <!-- <v-flex xs12 md3>
                <v-select
                  class="select-firm"
                  dense
                  :items="firmsByBrand"
                  label="Select Firm"
                  v-model="selectedFirm"
                  clearable
                ></v-select>
              </v-flex> -->
              

              <v-flex xs12 md3>
                <v-menu
                  :close-on-content-click="false"
                  v-model="datepickerFrom4"
                  :nudge-right="40"
                  class="ist-datepicker-dashboard"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  clearable
                >
                  <v-text-field
                    slot="activator"
                    v-model="fromDate"
                    label="From Date"
                    prepend-icon="event"
                    readonly
                    clearable
                  ></v-text-field>
                  <v-date-picker v-model="fromDate" @input="datepickerFrom4 = false"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex xs12 md3>
                <v-menu
                  :close-on-content-click="false"
                  v-model="datepickerTo4"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  class="ist-datepicker-dashboard"
                  offset-y
                  full-width
                  min-width="290px"
                  clearable
                >
                  <v-text-field
                    slot="activator"
                    v-model="toDate"
                    label="To Date"
                    prepend-icon="event"
                    readonly
                    clearable
                  ></v-text-field>
                  <v-date-picker v-model="toDate" @input="datepickerTo4 = false"></v-date-picker>
                </v-menu>
              </v-flex>
            </v-layout>
          </template>
        </v-flex>

        <v-card-text>
          <v-data-table :headers="getTranslatedHeaders(bankHeader)"  :items="getBankInvoices" class="elevation-1">
            <template
              slot="items"
              slot-scope="props"
              v-if="props.item.bank && props.item.bank==currentAccountKey"
            >
              <!-- <td>{{new Date(props.item.date).toLocaleDateString('en-GB')}}</td> -->
              <td class="primary--text font-weight-bold" v-html="renderDate(props.item.date)"></td>
              <td>{{ getFirmName(props.item.firm) }}</td>
              <!-- <td>{{ props.item['.key']}}</td> -->
              <template v-if="props.item.accountType">
              <template v-if="props.item.accountType  == 'Overdraft A/C' || props.item.accountType  == 'Loan A/C' ">
                <td>
                  <h3 class="error--text text--darken-4"> {{props.item.totalAmount}}</h3>
                </td>
                <td></td>
              </template>
              <template v-else>
                <td></td>
                <td>
                  <h3 class="success--text text--darken-4"> {{props.item.totalAmount}}</h3>
                </td>
              </template>
              </template>
              <template v-else>
              <template v-if="!props.item.isCredited">
                <td>
                  <h3 class="green--text text--darken-4"> {{props.item.totalAmount}}</h3>
                </td>
                <td></td>
              </template>
              <template v-if="props.item.isCredited">
                <td></td>
                <td>
                  <h3 class="red--text text--darken-4"> {{props.item.totalAmount}}</h3>
                </td>
              </template>
              </template>
              <td>{{ props.item.paymentType }}</td>
              <td>{{ props.item.remark }}</td>
            </template>
            <template slot="no-data">No Items</template>
          </v-data-table>
          <!-- </v-simple-table> -->
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- End Bank Accounts -->

    <!-- Start Profit - Money Out - Buyer - Item  Summary  -->
    <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
      <v-card>
        <template v-if="currentTitle == 'Profit'">
          <v-toolbar dark color="primary">
            <v-toolbar-title>RECEIVED PAYMENT DETAILS</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-flex xs12 sm6 md3>
              <v-autocomplete
                :items="firmsByBrand"
                :search-input.sync="searchInput"
                v-model="selectedFirm"
                cache-items
                class="mx-3"
                flat
                hide-no-data
                hide-details
                label="Select Firm"
                clearable
              ></v-autocomplete>
            </v-flex>
            <v-spacer></v-spacer>
            
            <v-btn icon dark @click="dialog = false">
              <v-icon>close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text>
            <v-data-table
              :headers="profitHeader"
              :items="getInvoices"
              hide-actions
              class="elevation-1 dashboardHead"
            >
              <template
                slot="items"
                slot-scope="props"
                v-if="props.item.profit && props.item.isCredited"
              >
                <td>
                  <b>{{new Date(props.item.closedDate).toLocaleDateString('en-GB')}}</b>
                </td>
                <td>
                  <b>{{ props.item['.key']}}</b>
                </td>
                <td>
                  <b>{{getFirmName(props.item.firm)}}</b>
                </td>
                <td>
                  <b>{{ props.item.rate }} %</b>
                </td>
                <td>
                  <h3 class="error--text text--darken-4">
                    <b>{{ props.item.principalValue }}</b>
                  </h3>
                </td>
                <td>
                  <h3 class="primary--text text--darken-4">
                    <b>{{ props.item.profit }}</b>
                  </h3>
                </td>
                <td>
                  <h3 class="success--text text--darken-4">
                    <b>{{ props.item.totalAmount }}</b>
                  </h3>
                </td>
                <td>
                  <b>{{ props.item.paymentType }}</b>
                </td>
              </template>
              <template slot="no-data">No Items</template>
            </v-data-table>
          </v-card-text>
        </template>
        <!-- End Profit Summary  -->

        <!-- Start Sales Summary -->
        <template v-if="currentTitle == 'Sales'">
        <v-toolbar dark color="primary">
        <v-flex xs12 md2 sm2>
          <h3 class="title font-weight-bold">
            Sales Register
          </h3>
        </v-flex>
        <v-spacer/>
          <v-btn icon dark @click="printSaleReport()">
            <v-icon>print</v-icon>
          </v-btn>
          <v-btn icon dark @click="dialog = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        
        <v-toolbar>
        <v-flex xs12 md3 sm3>
          <v-select
            class="select-firm-dashboard"
            dense
            :items="firmsByBrand"
            label="Select Firm"
            v-model="selectedFirm"
            clearable
          ></v-select>
        </v-flex>
        <v-spacer/>
        
        <v-flex xs12 md3 sm3>
          <v-menu
            :close-on-content-click="false"
            v-model="datepickerFrom5"
            :nudge-right="40"
            class="ist-datepicker-dashboard"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            min-width="290px"
            clearable
          >
            <v-text-field
              slot="activator"
              v-model="fromDate"
              label="From Date"
              prepend-icon="event"
              readonly
              clearable
            ></v-text-field>
            <v-date-picker v-model="fromDate" @input="datepickerFrom5 = false"></v-date-picker>
          </v-menu>
        </v-flex>
        <v-flex xs12 md3 sm3>
          <v-menu
            :close-on-content-click="false"
            v-model="datepickerTo5"
            :nudge-right="40"
            lazy
            transition="scale-transition"
            class="ist-datepicker-dashboard"
            offset-y
            full-width
            min-width="290px"
            clearable
          >
            <v-text-field
              slot="activator"
              v-model="toDate"
              label="To Date"
              prepend-icon="event"
              readonly
              clearable
            ></v-text-field>
            <v-date-picker v-model="toDate" @input="datepickerTo5 = false"></v-date-picker>
          </v-menu>
        </v-flex>
          </v-toolbar>
          <v-card-text>
            <v-data-table
              :headers="invoiceHeader"
              :items="getSaleInvoices"
              class="elevation-1 dashboardHead"
            >
              <template slot="items" slot-scope="props">
                <template v-if="props.item.totalColumn_buyer">
                  <td>
                    <b>
                      <h3>Total</h3>
                    </b>
                  </td>
                  <td>
                    <b>
                      <h3></h3>
                    </b>
                  </td>
                  <!-- <td>
                    <b>
                      <h3></h3>
                    </b>
                  </td> -->
                  <td>
                    <b>
                      <h3></h3>
                    </b>
                  </td>
                  <td>
                    <b>
                      <h3></h3>
                    </b>
                  </td>
                  <td>
                    <b>
                      <h3></h3>
                    </b>
                  </td>
                  <td>
                    <b>
                      <h4
                        class="success--text font-weight-bold"
                      >{{ props.item['totalAmount'] || 0 | amount}}</h4>
                    </b>
                  </td>
                  <td>
                    <b>
                      <h4 class="font-weight-bold">{{ props.item['basicAmount'] || 0 | amount}}</h4>
                    </b>
                  </td>
                  <td>
                    <b>
                      <h4 class="font-weight-bold">{{ props.item['gstTotal']|| 0 | amount}}</h4>
                    </b>
                  </td>
                  <td>
                    <b>
                      <h4 class="font-weight-bold">{{ props.item['discountAmount'] || 0 | amount}}</h4>
                    </b>
                  </td>
                  <td>
                    <b>
                      <h4
                        class="primary--text font-weight-bold"
                      >{{ props.item['paidAmount'] || 0 | amount}}</h4>
                    </b>
                  </td>
                  <td>
                    <b>
                      <h4
                        class="error--text font-weight-bold"
                      >{{ props.item['remainingAmount'] || 0 | amount}}</h4>
                    </b>
                  </td>
                  <td>
                    <b>
                      <h3></h3>
                    </b>
                  </td>
                  <td>
                    <b>
                      <h3></h3>
                    </b>
                  </td>
                  <td>
                    <b>
                      <h3></h3>
                    </b>
                  </td>
                  <td>
                    <b>
                      <h4></h4>
                    </b>
                  </td>
                  <td>
                    <b>
                      <h4></h4>
                    </b>
                  </td>
                  <td>
                      <b>
                        <h4></h4>
                      </b>
                    </td>
                     <td>
                      <b>
                        <h4></h4>
                      </b>
                    </td>
                     <td>
                      <b>
                        <h4></h4>
                      </b>
                    </td>
                  <td>
                    <b>
                      <h4
                        class="primary--text font-weight-bold"
                      >{{props.item['GST_3']|| 0 | amount}}</h4>
                    </b>
                  </td>
                  <td>
                    <b>
                      <h4
                        class="primary--text font-weight-bold"
                      >{{props.item['GST_5']|| 0 | amount}}</h4>
                    </b>
                  </td>
                  <td>
                    <b>
                      <h4
                        class="primary--text font-weight-bold"
                      >{{props.item['GST_12']|| 0 | amount}}</h4>
                    </b>
                  </td>
                  <td>
                    <b>
                      <h4
                        class="primary--text font-weight-bold"
                      >{{props.item['GST_18']|| 0 | amount}}</h4>
                    </b>
                  </td>
                  <td>
                    <b>
                      <h4
                        class="primary--text font-weight-bold"
                      >{{props.item['GST_28']|| 0 | amount}}</h4>
                    </b>
                  </td>
                  <td></td>
                </template>
                <template v-else>
                  <!-- <td><b>{{new Date(props.item.date).toLocaleDateString('en-GB')}}</b></td> -->
                  <td class="primary--text font-weight-bold" v-html="renderDate(props.item.date)"></td>
                  <td>
                    <!-- <v-icon @click="openProd(props.item)" color="primary">remove_red_eye</v-icon> -->
                    <v-menu offset-y>
                    <template v-slot:activator="{ on }">
                      <v-icon  v-on="on">more_vert</v-icon>
                    </template>
                    <v-list>
                      <v-list-tile
                         @click="openProd(props.item)"
                      >
                        <v-list-tile-title class="font-weight-bold primary--text">
                          <v-icon class="primary--text">
                            remove_red_eye
                          </v-icon>
                          View 
                        </v-list-tile-title>
                      </v-list-tile>
                       <v-list-tile
                       @click="printBasicInvoice(props.item)"
                      >
                        <v-list-tile-title class="font-weight-bold primary--text">
                          <v-icon class="primary--text">
                            picture_as_pdf
                          </v-icon>
                          Print
                        </v-list-tile-title>
                      </v-list-tile>
                         <v-list-tile
                      >
                       <router-link :to="{ name: 'InvoiceUpdate', params: {invoiceId: props.item['.key']}}">
                        <v-list-tile-title class="font-weight-bold primary--text">
                          <v-icon class="primary--text">
                            edit
                          </v-icon>
                          Edit
                        </v-list-tile-title>
                       </router-link>
                      </v-list-tile>
                    </v-list>
                  </v-menu>
                  </td>
                  <!-- <td>
                    <b>{{ props.item['.key']}}</b>
                  </td> -->
                  <td>
                    <b>{{ props.item.buyerId  &&  buyerById[props.item.buyerId]  ? buyerById[props.item.buyerId].name : ''}}</b>
                  </td>
                  <td>
                    <b>{{ props.item['invoiceId']}}</b>
                  </td>
                  <td>
                    <b
                      class="success--text font-weight-bold"
                    >{{ props.item['totalAmount'] || 0 | amount}}</b>
                  </td>
                  <td>
                    <b>{{ (props.item['totalAmount'] - getGSTtotal(props.item)) || 0 | amount }}</b>
                  </td>
                  <td>
                    <b>{{ getGSTtotal(props.item) || 0 | amount}}</b>
                  </td>
                  <td>
                    <b>{{ props.item['discountAmount'] || 0 | amount}}</b>
                  </td>
                  <td>
                    <b
                      class="primary--text font-weight-bold"
                    >{{ props.item['paidAmount'] || 0 | amount}}</b>
                  </td>
                  <td>
                    <b
                      class="error--text font-weight-bold"
                    >{{ props.item['remainingAmount'] || 0 | amount}}</b>
                  </td>
                  
                  <td>
                    <b>{{ props.item['duration']}}</b>
                  </td>
                  <td>
                    <b>{{ props.item['paymentType']}}</b>
                  </td>
                  <td>
                    <b>{{ props.item['status']}}</b>
                  </td>
                  <!-- <td>
                    <b>{{ props.item['transactionType']}}</b>
                  </td> -->
                  <td>
                    <b>{{ props.item['gstType']}}</b>
                  </td>
                  <td>
                      <b>{{(props.item['gstType'] == 'IGST' ?  getGSTtotal(props.item) || 0 : 0) | amount}}</b>
                    </td>
                    <td>
                     <b>{{(props.item['gstType'] == 'SGST|CGST' ?  getGSTtotal(props.item)/2 || 0 : 0) | amount}}</b>
                    </td>
                     <td>
                     <b>{{(props.item['gstType'] == 'SGST|CGST' ?  getGSTtotal(props.item)/2 || 0 : 0) | amount}}</b>
                    </td>
                  <td>
                    <b>{{ props.item['GST_Percentage_total'] ? props.item['GST_Percentage_total']['GST_3'] : '' || 0 | amount}}</b>
                  </td>
                  <td>
                    <b>{{ props.item['GST_Percentage_total'] ? props.item['GST_Percentage_total']['GST_5'] : '' || 0 | amount}}</b>
                  </td>
                  <td>
                    <b>{{ props.item['GST_Percentage_total'] ? props.item['GST_Percentage_total']['GST_12'] : ''|| 0 | amount}}</b>
                  </td>
                  <td>
                    <b>{{ props.item['GST_Percentage_total'] ? props.item['GST_Percentage_total']['GST_18'] : ''|| 0 | amount }}</b>
                  </td>
                  <td>
                    <b>{{ props.item['GST_Percentage_total'] ? props.item['GST_Percentage_total']['GST_28'] : ''|| 0 | amount }}</b>
                  </td>
                  <td>
                    <b>{{ props.item['adminEmail'] ? props.item['adminEmail']: '' }}</b>
                  </td>
                  <td>
                    <b>{{getFirmName(props.item.firm)}}</b>
                  </td>
                </template>
              </template>
              <template slot="no-data">No Items</template>
            </v-data-table>
            <!-- View Inside - Sale Invoice Dialog -->
            <v-dialog
              v-model="dialog11"
              persistent
              width="1000"
              v-if="selectedInvoice && selectedInvoice['.key']"
            >
              <v-card>
                <v-card-title class="title grey lighten-2" primary-title>
                  &nbsp; <b>{{selectedInvoice.buyerId ? buyerById[selectedInvoice.buyerId].name : ''}} </b>
                  <!-- {{selectedInvoice['.key']}} -->
                  <v-spacer></v-spacer>
                  <v-btn color="primary" text @click="dialog11 = false">
                    <v-icon dark>clear</v-icon>
                  </v-btn>
                </v-card-title>
                <v-card-text>
                  <v-layout row wrap>
                    <v-flex xs12 md4>
                      <!-- <b>key :-</b>
                      {{selectedInvoice['.key']}}
                      <br /> -->
                      <b>Name :-</b>
                      <!-- {{selectedInvoice.customer ? selectedInvoice.customer.name : ''}} -->
                        {{selectedInvoice.buyerId ? buyerById[selectedInvoice.buyerId].name : ''}}
                      <br />
                      <b>Firm :-</b>
                      {{getFirmName(selectedInvoice.firm)}}
                      <br />
                      <b>invoiceId :-</b>
                      {{selectedInvoice['invoiceId']}}
                      <br />
                      <b>Duration (in Days) :-</b>
                      {{selectedInvoice['duration']}}
                      <br />
                      <b>Payment Type :-</b>
                      {{selectedInvoice['paymentType']}}
                      <br />
                      <b>Status :-</b>
                      {{selectedInvoice['status']}}
                      <br />
                    </v-flex>
                    <v-flex xs12 md4>
                      <b class="success--text font-weight-bold">Total Amount:</b>
                       {{selectedInvoice['totalAmount']}}
                      <br />
                      <b class="primary--text font-weight-bold">Basic Amount:</b>
                       {{selectedInvoice['totalAmount'] - getGSTtotal(selectedInvoice)}}
                      <br />
                      <b class="primary--text font-weight-bold">Total GST: </b>
                       {{getGSTtotal(selectedInvoice)}}
                      <br />
                      <b class="green--text font-weight-bold">Deposite Amount:</b>
                       {{selectedInvoice['paidAmount']}}
                      <br />
                      <b class="red--text font-weight-bold">Remaining Amount:</b>
                       {{selectedInvoice['remainingAmount']}}
                      <br />
                      <b>Discount:</b>
                       {{selectedInvoice['discountAmount']}}
                      <br />
                    </v-flex>
                    <v-flex xs12 md4>
                      <!-- <b>Transaction Type :-</b>
                      {{selectedInvoice['transactionType']}}
                      <br /> -->
                      <b>GST Type: </b>
                      {{selectedInvoice['gstType']}}
                      <br />
                      <b>GST (3%): </b>
                       {{selectedInvoice['GST_Percentage_total']['GST_3']}}
                      <br />
                      <b>GST (5%): </b>
                       {{selectedInvoice['GST_Percentage_total']['GST_5']}}
                      <br />
                      <b>GST (12%): </b>
                       {{selectedInvoice['GST_Percentage_total']['GST_12']}}
                      <br />
                      <b>GST (18%):</b>
                       {{selectedInvoice['GST_Percentage_total']['GST_18']}}
                      <br />
                      <b>GST (28%): </b>
                       {{selectedInvoice['GST_Percentage_total']['GST_28']}}
                      <br />
                    </v-flex>
                  </v-layout>
                  <v-data-table
                    :headers="invoiceProductListHeader"
                    :items="selectedInvoice.items"
                    class="elevation-1 dashboardHead"
                  >
                    <template slot="items" slot-scope="props">
                      <td>
                        <b>{{ props.item['productName']}}</b>
                      </td>
                      <td>
                        <b>{{ props.item['HSN_code']}}</b>
                      </td>
                      <td>
                        <b>{{ props.item.taxableGST_rate}}</b>
                      </td>
                      <td>
                        <b>{{ props.item['productUnit']}}</b>
                      </td>
                      <td>
                        <b>{{ props.item['quantity']}}</b>
                      </td>
                      <td>
                        <b>{{ props.item.rate}}</b>
                      </td>
                    </template>
                    <template slot="no-data">No Items</template>
                  </v-data-table>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="primary" text @click="dialog11 = false">Close</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-card-text>
        </template>

        <template v-if="currentTitle == 'Credit Note'">
          <v-toolbar dark color="primary">
            <v-toolbar-title>Credit Note Register</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon dark @click="dialog = false">
              <v-icon>close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text>
            <v-data-table
              :headers="invoiceHeader"
              :items="getCreditNoteInvoices"
              class="elevation-1 dashboardHead"
            >
              <template slot="headerCell" slot-scope="{ header }">
                <span
                  class="subheading font-weight-light text-success text--darken-3"
                  v-text="header.text"
                />
              </template>
              <template slot="items" slot-scope="props">
                <template v-if="props.item.totalColum_credit">
                  <td>
                    <b>Total</b>
                  </td>
                  <!-- <td>
                    <b></b>
                  </td> -->
                  <td>
                    <b></b>
                  </td>
                  <td>
                    <b></b>
                  </td>
                  <td>
                    <b></b>
                  </td>
                  <td>
                    <b></b>
                  </td>
                  
                  <td>
                    <b> {{ props.item['totalAmount']}}</b>
                  </td>
                  <td>
                    <b> {{ props.item['basicAmount']}}</b>
                  </td>
                  <td>
                    <b> {{ props.item['gstTotal'].toFixed(2)}}</b>
                  </td>
                  <td>
                    <b> {{ props.item['discountAmount']}}</b>
                  </td>
                  <td>
                    <b> {{ props.item['paidAmount']}}</b>
                  </td>
                  <td>
                    <b> {{ props.item['remainingAmount']}}</b>
                  </td>
                  <td>
                    <b></b>
                  </td>
                  
                  <td>
                    <b></b>
                  </td>
                  
                  <td>
                    <b></b>
                  </td>
                  
                  <td>
                    <b></b>
                  </td>
                  
                  <td>
                    <b></b>
                  </td>
                  
                  <td>
                    <b>{{props.item['GST_3'].toFixed(2)}}</b>
                  </td>
                  <td>
                    <b>{{props.item['GST_5'].toFixed(2)}}</b>
                  </td>
                  <td>
                    <b>{{props.item['GST_12'].toFixed(2)}}</b>
                  </td>
                  <td>
                    <b>{{props.item['GST_18'].toFixed(2)}}</b>
                  </td>
                  <td>
                    <b>{{props.item['GST_28'].toFixed(2)}}</b>
                  </td>
                  <td></td>
                </template>
                <template v-else>
                  <td class="primary--text font-weight-bold" v-html="renderDate(props.item.date)"></td>
                  <td>
                    <v-icon @click="openProd(props.item)" color="primary">remove_red_eye</v-icon>
                  </td>
                  <!-- <td>
                    <b>{{ props.item['.key']}}</b>
                  </td> -->
                  <td>
                    <b>{{props.item.buyerId ? buyerById[props.item.buyerId].name : ''}}</b>
                  </td>
                  <td>
                    <b>{{ props.item['invoiceId']}}</b>
                  </td>
                  <td>
                    <b> {{ props.item['paidAmount']}}</b>
                  </td>
                  <td>
                    <b> {{ props.item['remainingAmount']}}</b>
                  </td>
                  <td>
                    <b> {{ props.item['totalAmount']}}</b>
                  </td>
                  <td>
                    <b> {{ props.item['totalAmount'] - getGSTtotal(props.item)}}</b>
                  </td>
                  <td>
                    <b> {{ getGSTtotal(props.item)}}</b>
                  </td>
                  <td>
                    <b> {{ props.item['discountAmount']}}</b>
                  </td>
                  <td>
                    <b>{{ props.item['duration']}}</b>
                  </td>
                  <td>
                    <b>{{ props.item['paymentType']}}</b>
                  </td>
                  <td>
                    <b>{{ props.item['status']}}</b>
                  </td>
                  <td>
                    <b>{{ props.item['transactionType']}}</b>
                  </td>
                  <td>
                    <b>{{ props.item['gstType']}}</b>
                  </td>
                  <td>
                    <b>{{(props.item['gstType'] == 'IGST' ?  getGSTtotal(props.item) || 0 : 0) | amount}}</b>
                  </td>
                  <td>
                   <b>{{(props.item['gstType'] != 'IGST' ?  getGSTtotal(props.item)/2 || 0 : 0) | amount}}</b>
                  </td>
                   <td>
                   <b>{{(props.item['gstType'] != 'IGST' ?  getGSTtotal(props.item)/2 || 0 : 0) | amount}}</b>
                  </td>
                  <td>
                    <b>{{ props.item['GST_Percentage_total'] ? props.item['GST_Percentage_total']['GST_3'] : ''}}</b>
                  </td>
                  <td>
                    <b>{{ props.item['GST_Percentage_total'] ? props.item['GST_Percentage_total']['GST_5'] : ''}}</b>
                  </td>
                  <td>
                    <b>{{ props.item['GST_Percentage_total'] ? props.item['GST_Percentage_total']['GST_12'] : ''}}</b>
                  </td>
                  <td>
                    <b>{{ props.item['GST_Percentage_total'] ? props.item['GST_Percentage_total']['GST_18'] : ''}}</b>
                  </td>
                  <td>
                    <b>{{ props.item['GST_Percentage_total'] ? props.item['GST_Percentage_total']['GST_28'] : ''}}</b>
                  </td>
                  <td>
                    <b>{{ props.item['adminEmail'] ? props.item['adminEmail']: '' }}</b>
                  </td>
                  <td>
                    <b>{{getFirmName(props.item.firm)}}</b>
                  </td>
                </template>
              </template>
              <template slot="no-data">No Items</template>
            </v-data-table>
          </v-card-text>
        </template>

        <template v-if="currentTitle == 'Debit Note'">
          <v-toolbar dark color="primary">
            <v-toolbar-title>Debit Note Register</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon dark @click="dialog = false">
              <v-icon>close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text>
            <v-data-table
              :headers="invoiceHeader"
              :items="getDebitNoteInvoices"
              class="elevation-1 dashboardHead"
            >
              <template slot="items" slot-scope="props">
                <template v-if="props.item.totalColum_debit">
                  <td>
                    <b>
                      <h2>Total</h2>
                    </b>
                  </td>
                  <td>
                    <b>
                      <h2></h2>
                    </b>
                  </td>
                  <td>
                    <b>
                      <h2></h2>
                    </b>
                  </td>
                  <!-- <td>
                    <b>
                      <h2></h2>
                    </b>
                  </td> -->
                  <td>
                    <b>
                      <h2></h2>
                    </b>
                  </td>
                  <td>
                    <b>
                      <h2></h2>
                    </b>
                  </td>
                  <td>
                    <b>
                      <h2></h2>
                    </b>
                  </td>
                  
                  <td>
                    <b>
                       {{ props.item['totalAmount']}} 
                    </b>
                  </td>
                  <td>
                    <b>
                       {{ props.item['basicAmount']}}
                    </b>
                  </td>
                  <td>
                    <b>
                      <h2> {{ props.item['gstTotal'].toFixed(2)}}</h2>
                    </b>
                  </td>
                  <td>
                    <b>
                      <h2> {{ props.item['discountAmount']}}</h2>
                    </b>
                  </td>
                  <td>
                    <b>
                       {{ props.item['paidAmount']}}  
                    </b>
                  </td>
                  <td>
                    <b>
                       {{ props.item['remainingAmount']}} 
                    </b>
                  </td>
                  <td>
                    <b></b>
                  </td>
                  <td>
                    <b></b>
                  </td>
                  <td>
                    <b></b>
                  </td>
                  <td>
                    <b></b>
                  </td>
                  <td>
                    <b></b>
                  </td>
                  <td>
                    <b></b>
                  </td>
                  <td>
                    <b></b>
                  </td>
                  <td>
                    <b></b>
                  </td>
                  <td>
                    <b>{{props.item['GST_3'].toFixed(2)}}</b>
                  </td>
                  <td>
                    <b>{{props.item['GST_5'].toFixed(2)}}</b>
                  </td>
                  <td>
                    <b>{{props.item['GST_12'].toFixed(2)}}</b>
                  </td>
                  <td>
                    <b>{{props.item['GST_18'].toFixed(2)}}</b>
                  </td>
                  <td>
                    <b>{{props.item['GST_28'].toFixed(2)}}</b>
                  </td>
                  
                </template>
                <template v-else>
                  <td class="primary--text font-weight-bold" v-html="renderDate(props.item.date)"></td>
                  <td>
                    <v-icon @click="openProd(props.item)" color="primary">remove_red_eye</v-icon>
                  </td>
                  <!-- <td>
                    <b>{{ props.item['.key']}}</b>
                  </td> -->
                  <td>
                    <b>{{ props.item.buyerId ? sellerById[props.item.buyerId].name : ''}}</b>
                  </td>
                  <td>
                    <b>{{ props.item['invoiceId']}}</b>
                  </td>
                  
                  <td>
                    <b> {{ props.item['totalAmount']}}</b>
                  </td>
                  <td>
                    <b> {{ props.item['totalAmount'] - getGSTtotal(props.item)}}</b>
                  </td>
                  <td>
                    <b> {{ getGSTtotal(props.item)}}</b>
                  </td>
                  <td>
                    <b> {{ props.item['discountAmount']}}</b>
                  </td>
                  <td>
                    <b> {{ props.item['paidAmount']}}</b>
                  </td>
                  <td>
                    <b> {{ props.item['remainingAmount']}}</b>
                  </td>
                  <td>
                    <b>{{ props.item['duration']}}</b>
                  </td>
                  <td>
                    <b>{{ props.item['paymentType']}}</b>
                  </td>
                  <td>
                    <b>{{ props.item['status']}}</b>
                  </td>
                  <td>
                    <b>{{ props.item['transactionType']}}</b>
                  </td>
                  <td>
                    <b>{{ props.item['gstType']}}</b>
                  </td>
                  <td>
                    <b>{{(props.item['gstType'] == 'IGST' ?  getGSTtotal(props.item) || 0 : 0) | amount}}</b>
                  </td>
                  <td>
                   <b>{{(props.item['gstType'] != 'IGST' ?  getGSTtotal(props.item)/2 || 0 : 0) | amount}}</b>
                  </td>
                   <td>
                   <b>{{(props.item['gstType'] != 'IGST' ?  getGSTtotal(props.item)/2 || 0 : 0) | amount}}</b>
                  </td>
                  <td>
                    <b>{{ props.item['GST_Percentage_total'] ? props.item['GST_Percentage_total']['GST_3'] : ''}}</b>
                  </td>
                  <td>
                    <b>{{ props.item['GST_Percentage_total'] ? props.item['GST_Percentage_total']['GST_5'] : ''}}</b>
                  </td>
                  <td>
                    <b>{{ props.item['GST_Percentage_total'] ? props.item['GST_Percentage_total']['GST_12'] : ''}}</b>
                  </td>
                  <td>
                    <b>{{ props.item['GST_Percentage_total'] ? props.item['GST_Percentage_total']['GST_18'] : ''}}</b>
                  </td>
                  <td>
                    <b>{{ props.item['GST_Percentage_total'] ? props.item['GST_Percentage_total']['GST_28'] : ''}}</b>
                  </td>
                  <td>
                    <b>{{getFirmName(props.item.firm)}}</b>
                  </td>
                </template>
              </template>
              <template slot="no-data">No Items</template>
            </v-data-table>
          </v-card-text>
        </template>
        <!-- End Money Out Summary -->

        <!-- Start Purchase Summary -->
        <template v-if="currentTitle == 'Purchase'">
        <v-toolbar dark color="primary">
          <v-flex xs12 md2 sm2>
            <h3 class="title font-weight-bold">
              Purchase Register
            </h3>
          </v-flex>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="printPurchaseReport()"><v-icon>print</v-icon></v-btn>
          <v-btn icon dark @click="dialog = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-toolbar>  
        <v-flex xs12 md3 sm3>
          <v-select
            class="select-firm-dashboard"
            dense
            :items="firmsByBrand"
            label="Select Firm"
            v-model="selectedFirm"
            clearable
          ></v-select>
        </v-flex>
        <v-spacer/>
        
        <v-flex xs12 md3 sm3>
          <v-menu
            :close-on-content-click="false"
            v-model="datepickerFrom6"
            :nudge-right="40"
            class="ist-datepicker-dashboard"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            min-width="290px"
            clearable
          >
            <v-text-field
              slot="activator"
              v-model="fromDate"
              label="From Date"
              prepend-icon="event"
              readonly
              clearable
            ></v-text-field>
            <v-date-picker v-model="fromDate" @input="datepickerFrom6 = false"></v-date-picker>
          </v-menu>
        </v-flex>
        <v-flex xs12 md3 sm3>
          <v-menu
            :close-on-content-click="false"
            v-model="datepickerTo6"
            :nudge-right="40"
            lazy
            transition="scale-transition"
            class="ist-datepicker-dashboard"
            offset-y
            full-width
            min-width="290px"
            clearable
          >
            <v-text-field
              slot="activator"
              v-model="toDate"
              label="To Date"
              prepend-icon="event"
              readonly
              clearable
            ></v-text-field>
            <v-date-picker v-model="toDate" @input="datepickerTo6 = false"></v-date-picker>
          </v-menu>
        </v-flex>
          </v-toolbar>
          <v-card-text>
            <v-data-table
              :headers="invoiceHeader"
              :items="getPurchaseInvoices"
              class="elevation-1 dashboardHead"
            >
              <template slot="items" slot-scope="props">
                <template v-if="props.item.totalColum_seller">
                  <td>
                    <b>Total</b>
                  </td>
                  <!-- <td>
                    <b></b>
                  </td> -->
                  <td>
                    <b></b>
                  </td>
                  <td>
                    <b></b>
                  </td>
                  <td>
                    <b></b>
                  </td>
                  <td>
                    <b></b>
                  </td>
                  
                  <td>
                    <b
                      class="success--text font-weight-bold"
                    >{{ props.item['totalAmount']|| 0 | amount }}</b>
                  </td>
                  <td>
                    <b>{{ props.item['basicAmount']|| 0 | amount }}</b>
                  </td>
                  <td>
                    <b>{{ props.item['gstTotal'] || 0 | amount}}</b>
                  </td>
                  <td>
                    <b>{{ props.item['discountAmount']|| 0 | amount }}</b>
                  </td>
                  <td>
                    <b
                      class="primary--text font-weight-bold"
                    >{{ props.item['paidAmount'] || 0 | amount}}</b>
                  </td>
                  <td>
                    <b
                      class="error--text font-weight-bold"
                    >{{ props.item['remainingAmount']|| 0 | amount }}</b>
                  </td>
                  <td>
                    <b></b>
                  </td>
                  <td>
                    <b></b>
                  </td>
                  <td>
                    <b></b>
                  </td>
                  <td>
                    <b></b>
                  </td>
                  <td>
                     <b></b>
                   </td>
                   <td>
                    <b></b>
                  </td>
                   <td>
                    <b></b>
                  </td>
                   <td>
                    <b></b>
                  </td>
                  <td>
                    <b>{{props.item['GST_3'] || 0 | amount}}</b>
                  </td>
                  <td>
                    <b>{{props.item['GST_5'] || 0 | amount}}</b>
                  </td>
                  <td>
                    <b>{{props.item['GST_12'] || 0 | amount}}</b>
                  </td>
                  <td>
                    <b>{{props.item['GST_18'] || 0 | amount}}</b>
                  </td>
                  <td>
                    <b>{{props.item['GST_28'] || 0 | amount}}</b>
                  </td>
                  <td></td>
                </template>
                <template v-else>
                  <!-- <td><b>{{new Date(props.item.date).toLocaleDateString('en-GB')}}</b></td> -->
                  <td class="primary--text font-weight-bold" v-html="renderDate(props.item.date)"></td>
                  <td>
                    <!-- <v-icon @click="openProd(props.item)" color="primary">remove_red_eye</v-icon> -->
                    <v-menu offset-y>
                    <template v-slot:activator="{ on }">
                      <v-icon  v-on="on">more_vert</v-icon>
                    </template>
                    <v-list>
                      <v-list-tile
                         @click="openProd(props.item)"
                      >
                        <v-list-tile-title class="font-weight-bold primary--text" >
                          <v-icon class="primary--text">
                            remove_red_eye
                          </v-icon>
                          View
                        </v-list-tile-title>
                      </v-list-tile>
                       <v-list-tile
                        @click="printBasicInvoice(props.item)"
                      >
                        <v-list-tile-title class="font-weight-bold primary--text">
                          <v-icon class="primary--text">
                            picture_as_pdf
                          </v-icon>
                          Print</v-list-tile-title>
                      </v-list-tile>
                         <v-list-tile
                      >
                        <router-link :to="{ name: 'InvoiceUpdate', params: {invoiceId: props.item['.key']}}">
                        <v-list-tile-title class="font-weight-bold primary--text">
                          <v-icon class="primary--text">
                            edit
                          </v-icon>
                          Edit
                        </v-list-tile-title>
                       </router-link>
                      </v-list-tile>
                    </v-list>
                  </v-menu>
                  </td>
                  <!-- <td>
                    <b>{{ props.item['.key']}}</b>
                  </td> -->
                  <td>
                    <b>{{ props.item.buyerId ? sellerById[props.item.buyerId].name : ''}}</b>
                  </td>
                  <td>
                    <b>{{ props.item['invoiceId']}}</b>
                  </td>
                  <td>
                    <b
                      class="success--text font-weight-bold"
                    >{{ props.item['totalAmount'] || 0 | amount}}</b>
                  </td>
                  <td>
                    <b>{{ props.item['totalAmount'] - getGSTtotal(props.item)}}</b>
                  </td>
                  <td>
                    <b>{{ getGSTtotal(props.item)}}</b>
                  </td>
                  <td>
                    <b>{{ props.item['discountAmount']}}</b>
                  </td>
                  <td>
                    <b
                      class="primary--text font-weight-bold"
                    >{{ props.item['paidAmount'] || 0 | amount }}</b>
                  </td>
                  <td>
                    <b
                      class="error--text font-weight-bold"
                    >{{ props.item['remainingAmount'] || 0 | amount}}</b>
                  </td>
                  <td>
                    <b>{{ props.item['duration']}}</b>
                  </td>
                  <td>
                    <b>{{ props.item['paymentType']}}</b>
                  </td>
                  <td>
                    <b>{{ props.item['status']}}</b>
                  </td>
                  <!-- <td>
                    <b>{{ props.item['transactionType']}}</b>
                  </td> -->
                  <td>
                    <b>{{ props.item['gstType']}}</b>
                  </td>
                  <td>
                    <b>{{(props.item['gstType'] == 'IGST' ?  getGSTtotal(props.item) || 0 : 0) | amount}}</b>
                  </td>
                  <td>
                   <b>{{(props.item['gstType'] != 'IGST' ?  getGSTtotal(props.item)/2 || 0 : 0) | amount}}</b>
                  </td>
                   <td>
                   <b>{{(props.item['gstType'] != 'IGST' ?  getGSTtotal(props.item)/2 || 0 : 0) | amount}}</b>
                  </td>
                  <td>
                    <b>{{ props.item['GST_Percentage_total'] ? props.item['GST_Percentage_total']['GST_3'] : ''}}</b>
                  </td>
                  <td>
                    <b>{{ props.item['GST_Percentage_total'] ? props.item['GST_Percentage_total']['GST_5'] : ''}}</b>
                  </td>
                  <td>
                    <b>{{ props.item['GST_Percentage_total'] ? props.item['GST_Percentage_total']['GST_12'] : ''}}</b>
                  </td>
                  <td>
                    <b>{{ props.item['GST_Percentage_total'] ? props.item['GST_Percentage_total']['GST_18'] : ''}}</b>
                  </td>
                  <td>
                    <b>{{ props.item['GST_Percentage_total'] ? props.item['GST_Percentage_total']['GST_28'] : ''}}</b>
                  </td>
                  <td>
                    <b>{{ props.item['adminEmail'] ? props.item['adminEmail']: '' }}</b>
                  </td>
                  <td>
                    <b>{{getFirmName(props.item.firm)}}</b>
                  </td>
                </template>
              </template>
              <template slot="no-data">No Items</template>
            </v-data-table>
            <!-- view Inside purchase Invoice  -->
            <v-dialog
              v-model="dialog11"
              persistent
              width="1000"
              v-if="selectedInvoice && selectedInvoice['.key']"
            >
              <v-card>
                <v-card-title class="title grey lighten-2" primary-title>
                  <!-- {{selectedInvoice['.key']}} -->
                  {{selectedInvoice.buyerId ? sellerById[selectedInvoice.buyerId].name : ''}}
                  <v-spacer></v-spacer>
                  <v-btn color="primary" text @click="dialog11 = false">
                    <v-icon dark>clear</v-icon>
                  </v-btn>
                </v-card-title>
                <v-card-text>
                  <v-layout row wrap>
                    <v-flex xs12 md4>
                      <!-- <b>key :-</b>
                      {{selectedInvoice['.key']}}
                      <br /> -->
                      <b>Name: </b>
                      {{ selectedInvoice.buyerId ? sellerById[selectedInvoice.buyerId].name : ''}}
                      <!-- {{selectedInvoice.customer ? selectedInvoice.customer.name : ''}} -->
                      <br />
                      <b>Firm: </b>
                      {{getFirmName(selectedInvoice.firm)}}
                      <br />
                      <b>invoiceId: </b>
                      {{selectedInvoice['invoiceId']}}
                      <br />
                      <b>Payment Type: </b>
                      {{selectedInvoice['paymentType']}}
                      <br />
                      <b>Status: </b>
                      {{selectedInvoice['status']}}
                      <br />
                      <b>Duration (in Days): </b>
                      {{selectedInvoice['duration']}}
                      <br />
                    </v-flex>
                    <v-flex xs12 md4>
                      <b class="font-weight-bold green--text">Total Amount: </b>
                       {{selectedInvoice['totalAmount']}}
                      <br />
                      <b class="font-weight-bold primary--text">Basic Amount: </b>
                       {{selectedInvoice['totalAmount'] - getGSTtotal(selectedInvoice)}}
                      <br />
                      <b class="font-weight-bold primary--text">GST: </b>
                       {{getGSTtotal(selectedInvoice)}}
                      <br />
                      <b class="font-weight-bold success--text">Deposit Amount: </b>
                       {{selectedInvoice['paidAmount']}}
                      <br />
                      <b class="font-weight-bold red--text">Remaining Amount: </b>
                       {{selectedInvoice['remainingAmount']}}
                      <br />
                      <b>Discount: </b>
                       {{selectedInvoice['discountAmount']}}
                      <br />
                    </v-flex>
                    <v-flex xs12 md4>
                      <!-- <b>Transaction Type: </b>
                      {{selectedInvoice['transactionType']}}
                      <br /> -->
                      <b>GST Type: </b>
                      {{selectedInvoice['gstType']}}
                      <br />
                      <b>GST (0%): </b>
                       {{selectedInvoice['GST_Percentage_total']['GST_3']}}
                      <br />
                      <b>GST (5%): </b>
                       {{selectedInvoice['GST_Percentage_total']['GST_5']}}
                      <br />
                      <b>GST (12%): </b>
                       {{selectedInvoice['GST_Percentage_total']['GST_12']}}
                      <br />
                      <b>GST (18%): </b>
                       {{selectedInvoice['GST_Percentage_total']['GST_18']}}
                      <br />
                      <b>GST (28%): </b>
                       {{selectedInvoice['GST_Percentage_total']['GST_28']}}
                      <br />
                    </v-flex>
                  </v-layout>
                  <br/>
                  <v-data-table
                    :headers="invoiceProductListHeader"
                    :items="selectedInvoice.items"
                    class="elevation-1 dashboardHead"
                  >
                    <template slot="items" slot-scope="props">
                      <td>
                        <b>{{ props.item['productName']}}</b>
                      </td>
                      <td>
                        <b>{{ props.item['HSN_code']}}</b>
                      </td>
                      <td>
                        <b>{{ props.item.taxableGST_rate}}</b>
                      </td>
                      <td>
                        <b>{{ props.item['productUnit']}}</b>
                      </td>
                      <td>
                        <b>{{ props.item['quantity']}}</b>
                      </td>
                      <td>
                        <b>{{ props.item.rate}}</b>
                      </td>
                    </template>
                    <template slot="no-data">No Items</template>
                  </v-data-table>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="primary" text @click="dialog11 = false">Close</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-card-text>
        </template>
        <!-- End Money Out Summary -->

        <!-- Start Buyer Summary -->
        <template v-if="currentTitle == 'Customer'">
          <v-toolbar class="primary white--text">
            <v-toolbar-title>CUSTOMER INFORMATION</v-toolbar-title>
            <v-spacer/>
             <v-text-field
                style="margin-top: 10px;"
                prepend-inner-icon="search"
                solo
                outlined
                clearable 
                label="Search Customer" 
                @keyup.native="keymonitorCustomer($event)" />
            <v-spacer/>
            <v-btn icon dark @click="dialog = false">
              <v-icon>close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text>
            <v-data-table
              :headers="buyerHeader"
              :items="itemList"
              hide-actions
              class="elevation-1 dashboardHead"
            >
              <template
                slot="items"
                slot-scope="props"
                v-if="props.item.name || props.item.propName"
              >
                <td>
                  <b>{{ props.item['.key']}}</b>
                </td>
                <td>
                  <!-- <b class="primary--text">{{ props.item.name }}</b> -->
                  <b class="primary--text">
                    <router-link :to="{ name: 'BuyersInfo', params : {buyerId : props.item['.key']}}" style="text-decoration: none;">
                      {{ props.item.name }}
                    </router-link>
                  </b>
                </td>
                <td>
                  <b>{{ props.item.propName }}</b>
                </td>
                <!-- <td>
                  <b>{{ props.item.village }}</b>
                </td>
                <td>
                  <b>{{ props.item.block }}</b>
                </td> -->
                <td>
                  <b>{{ props.item.localAddress }}</b>
                </td>
                <td>
                  <b>{{ props.item.tehsil }}</b>
                </td>
                <td>
                  <b>{{ props.item.district }}</b>
                </td>
                <td>
                  <b class="primary--text">{{ props.item.mobile }}</b>
                </td>
                <td>
                  <b>{{ props.item.identityType }}</b>
                </td>
                <td>
                  <b>{{ props.item.identityNumber }}</b>
                </td>
              </template>
              <template slot="no-data">No Items</template>
            </v-data-table>
          </v-card-text>
        </template>
        <!-- End Buyer -->

        <!-- Start Items In Summary -->
        <!-- <template v-if="currentTitle == 'Items In'">
          <router-link class="nav-link" to="/items">
            <v-btn large class="primary white--text">
              View Items
              <v-icon right dark>shopping_cart</v-icon>
            </v-btn>
          </router-link>
        </template> -->
        <!-- End Items In Summary -->
      </v-card>
    </v-dialog>
    <!-- End Basic Details -->

    <!-- Expense Dialog -->
    <v-dialog v-model="expenseDialog" persistent fullscreen hide-overlay transition="dialog-bottom-transition">
      <v-card>
        <v-card-title primary title class="primary white--text">
          <h2>{{$t("Expense Details")}}</h2>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="expenseDialog = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-data-table :headers="expenseHeader" :items="getExpenseInvoices" class="elevation-1">
            <template
              slot="items"
              slot-scope="props"
              v-if="props.item.expenseType == currentExpense"
            >
              <td class="primary--text font-weight-bold" v-html="renderDate(props.item.date)"></td>
              <td>{{ props.item['.key']}}</td>
              <td>{{ getFirmName(props.item.firm) }}</td>
              <td>{{ props.item.paymentType }}</td>
              <td class="red--text text--darken-4">{{ props.item.totalAmount }}/-</td>
              <td>{{ props.item.remark }}</td>
            </template>
            <template slot="no-data">No Items</template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Income Dialog -->
    <v-dialog v-model="incomeDialog" fullscreen hide-overlay transition="dialog-bottom-transition">
      <v-card>
        <v-card-title primary title class="primary white--text">
          <h2>Income Details</h2>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="incomeDialog = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-data-table :headers="incomeAccHeader" :items="getIncomeInvoices" class="elevation-1">
            <template slot="items" slot-scope="props" v-if="props.item.incomeType == currentIncome">
              <!-- <td color="black" outline><h2>{{new Date(props.item.date).toLocaleDateString('en-GB')}}</h2></td> -->
              <td class="primary--text font-weight-bold" v-html="renderDate(props.item.date)"></td>
              <td>{{ props.item['.key']}}</td>
              <td>{{ getFirmName(props.item.firm) }}</td>
              <td>{{ props.item.paymentType }}</td>
              <td class="green--text text--darken-4">{{ props.item.totalAmount }}/-</td>
              <td>{{ props.item.remark }}</td>
            </template>
            <template slot="no-data">No Items</template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Staff Dialog -->
    <v-dialog v-model="staffDialog" fullscreen hide-overlay transition="dialog-bottom-transition">
      <v-card>
        <v-card-title primary title class="primary white--text">
          <h2>Staff Details</h2>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="staffDialog = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-data-table :headers="salaryHeader" :items="getStaffInvoices" class="elevation-1">
            <template slot="items" slot-scope="props" v-if="props.item.staffkey == currentStaff">
              <!-- <td color="black" outline><h2>{{new Date(props.item.date).toLocaleDateString('en-GB')}}</h2></td> -->
              <td class="primary--text font-weight-bold" v-html="renderDate(props.item.date)"></td>
              <td>{{ props.item['.key']}}</td>
              <td>{{ getFirmName(props.item.firm) }}</td>
              <td>{{ props.item.paymentType }}</td>
              <!-- <td class="warning--text text--darken-4">{{ props.item.totalAmount }}/-</td> -->
              <td v-if="['advance','salary','commission'].includes(props.item.salaryType)" class="red--text font-weight-bold">{{ props.item.totalAmount || 0 | amount }}/-</td><td v-else></td>
              <td v-if="['return'].includes(props.item.salaryType)" class="green--text font-weight-bold">{{ props.item.totalAmount || 0 | amount }}/-</td> <td v-else></td>
              <td>{{ props.item.remark }}</td>
            </template>
            <template slot="no-data">No Items</template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Asset Dialog -->
    <v-dialog v-model="assetDialog" fullscreen hide-overlay transition="dialog-bottom-transition">
      <v-card>
        <v-card-title primary title class="primary white--text">
          <h2>Asset Details</h2>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="assetDialog = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-data-table
            :headers="assetHeader"
            :items="getAssetInvoices"
            class="elevation-1 dashboardHead"
          >
            <template slot="items" slot-scope="props" v-if="props.item.assetType == currentAsset">
              <!-- <td color="black" outline><h2>{{new Date(props.item.date).toLocaleDateString('en-GB')}}</h2></td> -->
              <td class="primary--text font-weight-bold" v-html="renderDate(props.item.date)"></td>
              <td>{{ props.item['.key']}}</td>
              <td>{{ getFirmName(props.item.firm) }}</td>
              <td>{{ props.item.paymentType }}</td>
              <td class="success--text text--darken-4">{{ props.item.totalAmount }}/-</td>
              <td>{{ props.item.remark }}</td>
            </template>
            <template slot="no-data">No Items</template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>


<script>
import { createNamespacedHelpers } from "vuex";
// import { convertToPDFSaleReport } from "../../utils/pdf-reports/dashboard-reports";
import { convertToPDFReport } from "../../utils/pdf-reports/dashboard-reports";
import { convertToBasicInvoice,convertToBasicInvoiceWithoutGST } from "../../utils/pdfmake";
import i18n from '@/i18n';
import { getGSTPercentageTotal } from "../../utils/";
let brand = window.localStorage.getItem('brand')
//let brandFinYear = window.localStorage.getItem('brandFinYear')
const mapGlobalGetters = createNamespacedHelpers("Global")["mapGetters"];
import VueApexCharts from "vue-apexcharts";
export default {
  components: {
    apexchart: VueApexCharts
  },
  data() {
    return {
      topCustomerFilter : 'All',
      tradeOptions: {
        chart: {
          id: "vuechart-trade",
          events: {
            click: (event, chartContext, config)=> {
              let index = config.dataPointIndex;
              let month = (index + (index < 8 ? 3 : -9));
              if(config.seriesIndex) {
                this.$router.push({ path: `/purchase-register/${month}/0` });
              } else {
                this.$router.push({ path: `/sale-register/${month}/0` });
              }
            }
          }
        },
        xaxis: {
          categories: [
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December",
            "January",
            "February",
            "March",
          ]
        }
      },
      tab: null,
      tradeData: [
        {
          name: "Sale",
          data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
        },
        {
          name: "Purchase",
          data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
        }
      ],
      volumeOptionsDaily: {
        chart: {
          id: "vuechart-daily",
          events: {
            click: (event, chartContext, config)=> {
              let date = config.dataPointIndex;
              let index = new Date().getMonth();
              if(config.seriesIndex) {
                this.$router.push({ path: `/purchase-register/${index}/${date+1}` });
              } else {
                this.$router.push({ path: `/sale-register/${index}/${date+1}` });
              }
            }
          } 
        },
        xaxis: {
          categories: []
        }
      },
      volumeDataDaily: [
        {
          name: "sale",
          data: []
        },
        {
          name: "Purchase",
          data: []
        }
      ],
      volumeOptions: {
        chart: {
          id: "vuechart-volume"
        },
        xaxis: {
          categories: [
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December",
            "January",
            "February",
            "March",
          ]
        }
      },
      volumeData: [
        {
          name: "sale",
          data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
        },
        {
          name: "Purchase",
          data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
        }
      ],
      cards1: [
        {
          title: "Customer",
          buyerCount: 0,
          sellerCount: 0
        },
        {
          title: "Sales",
          value: 0,
          amount: 0
        },
        {
          title: "Purchase",
          value: 0,
          amount: 0
        },
        {
          title: "Stock",
          measure: 0.0,
          aggregate: 0.0
        }
      ],
      cards2: [
        {
          title: "Profit",
          value: 0.0,
          amount: 0.0
        },
        {
          title: "Credit Note",
          amount: 0.0,
          count: 0
        },
        {
          title: "Debit Note",
          amount: 0.0,
          count: 0
        }
      ],
      topProdHead: [
        { text: "Product Name", value: "Product Name", sortable: false },
        { text: "Units", value: "Units", sortable: false },
        { text: "Quantity", value: "quantity", sortable: true },
        { text: "Sold duration", value: "Amount", sortable: false }
        // { text: "Amount", value: "Amount", sortable: false }
      ],
      topCustHead: [
        { text: "Person Name", value: "name", sortable: true },
        { text: "Total Amount", value: "totalAmount", sortable: true },
        { text: "Paid Amount", value: "paidAmount", sortable: true },
        { text: "Remaining Amount", value: "remainingAmount", sortable: true }
      ],
      buyerHeader: [
        // { text: "Buyer - ID", value: "Buyer - ID" },
        { text: "Name", value: "Name" },
        { text: "Prop Name", value: "Father Name" },
        { text: "Address", value: "localAddress" },
        // { text: "Village", value: "Village" },
        // { text: "Block", value: "Block" },
        { text: "Tehsil", value: "Tehsil" },
        { text: "District", value: "District" },
        { text: "Mobile", value: "Mobile" },
        { text: "Identity Type", value: "Identity Type" },
        { text: "Identity Number", value: "Identity Number" },
      ],
      invoiceHeader: [
        { text: "Date", value: "date", sortable: true },
        { text: "Action", value: "action" },
        // { text: "Invoice - Key", value: "Name" },
        { text: "Buyer Name", value: "Father Name" },
        { text: "Invoice No", value: "invoiceId", sortable: true  },
        { text: "Total Amount", value: "totalCurrentAmount" },
        { text: "Basic Amount", value: "basic amount" },
        { text: "GST", value: "GST" },
        { text: "Discount", value: "discount" },
        { text: "Deposited Amount", value: "Tehsil" },
        { text: "Remaining Amount", value: "District" },
        { text: "Duration (in Days)", value: "abs" },
        { text: "Payment Type", value: "Identity Number" },
        { text: "Status", value: "Mobile" },
        // { text: "Transaction Type", sortable: true, value: "paymentType" },
        { text: "GST Type", sortable: true, value: "gstType" },
        { text: "IGST Value", sortable: true, value: "gstType" },
        { text: "SGST Value", sortable: true, value: "gstType" },
        { text: "CGST Value", sortable: true, value: "gstType" },
        { text: "GST (0%)", sortable: true, value: "gstType" },
        { text: "GST (5%)", sortable: true, value: "gstType" },
        { text: "GST (12%)", sortable: true, value: "gstType" },
        { text: "GST (18%)", sortable: true, value: "gstType" },
        { text: "GST (28%)", sortable: true, value: "gstType" },
        { text: "Admin email", sortable: true, value: "gstType" },
        { text: "Firm Name", value: "Village" },
      ],
      profitHeader: [
        { text: "Date", value: "date", sortable: true },
        { text: "Invoice - No", value: "Name" },
        { text: "Firm Name", value: "Father Name" },
        { text: "Rate of Interest", value: "Village" },
        { text: "Principal Value", value: "Block" },
        { text: "Interest Value", value: "Tehsil" },
        { text: "Total Value", value: "District" },
        { text: "Payment Type", value: "Identity Type" }
      ],
      firmHeader: [
        { text: "Date", value: "date", sortable: true },
        { text: "Firm Name", value: "Name" },
        { text: "Customer Name", value: "customerName" },
        { text: "Invoice No", value: "Father Name" },
        { text: "Debit", value: "Tehsil" },
        { text: "Credit", value: "District" },
        { text: "Payment Type", value: "paymentType" },
        { text: "Status", value: "identityType" },
        { text: "Vocher", value: "Vocher Type" },
        { text: "Remark", value: "remark" }
      ],
      bankHeader: [
        { text: "Date", value: "date", sortable: true },
        { text: "Firm Name", value: "Name" },
        // { text: "Transaction -ID", value: "Father Name" },
        { text: "Debit", value: "Tehsil" },
        { text: "Credit", value: "District" },
        { text: "Transaction Type", value: "Village" },
        { text: "Remark", value: "Identity Type" }
      ],
      expenseHeader: [
        { text: "Date", value: "date", sortable: true },
        { text: "Invoice ID", value: "Name" },
        { text: "Firm Name", value: "Father Name" },
        { text: "Payment Type", value: "Village" },
        { text: "Amount", value: "Block" },
        { text: "Remark", value: "Identity Type" }
      ],
      incomeAccHeader: [
        { text: "Date", value: "date", sortable: true },
        { text: "Invoice ID", value: "Name" },
        { text: "Firm Name", value: "Father Name" },
        { text: "Payment Type", value: "Village" },
        { text: "Amount", value: "Block" },
        { text: "Remark", value: "Tehsil" }
      ],
      salaryHeader: [
        { text: "Date", value: "date", sortable: true },
        { text: "Invoice ID", value: "Name" },
        { text: "Firm Name", value: "Father Name" },
        { text: "Payment Type", value: "Village" },
        { text: "Debit", value: "Tehsil" },
        { text: "Credit", value: "District" },
        { text: "Remark", value: "Tehsil" }
      ],
      assetHeader: [
        { text: "Date", value: "date", sortable: true },
        { text: "Invoice ID", value: "Name" },
        { text: "Firm Name", value: "Father Name" },
        { text: "Payment Type", value: "Village" },
        { text: "Debit", value: "Tehsil" },
        { text: "Credit", value: "District" },
        { text: "Remark", value: "Tehsil" }
      ],
      invoiceProductListHeader: [
        { text: "Name", value: "Name", class: "font-weight-bold primary--text" },
        { text: "HSN code", value: "HSN", class: "font-weight-bold primary--text" },
        { text: "Taxable rate", value: "Taxable", class: "font-weight-bold primary--text" },
        { text: "Unit", value: "Unit", class: "font-weight-bold primary--text" },
        { text: "Quantity", value: "quantity", class: "font-weight-bold primary--text" },
        { text: "Rate", value: "rate", class: "font-weight-bold primary--text" }
      ],
      totalclosingStock : 0,
      selectedInvoice: {},
      firms: [],
      datepickerFrom : false,
      datepickerFrom2 : false,
      datepickerFrom3 : false,
      datepickerFrom4 : false,
      datepickerFrom5 : false,
      datepickerFrom6 : false,
      datepickerTo : false,
      datepickerTo2 : false,
      datepickerTo3 : false,
      datepickerTo4 : false,
      datepickerTo5 : false,
      datepickerTo6 : false,
      isFilter : false,
      toDate: null,
      fromDate: null,
      buyers: [],
      items: [],
      invoices: [],
      totalSales: 0,
      totalPurchase: 0,
      totalCreditNote: 0,
      totalDebitNote: 0,
      credited: 0.0,
      debited: 0.0,
      itemsInStock: 0,
      dialog: false,
      dialog1: false,
      dialog11: false,
      currentTitle: null,
      searchInput: null,
      expenseDialog: false,
      currentExpense: null,
      selectedFirm: null,
      totalExpenseAmount: 0.0,
      incomeDialog: false,
      accountDialog: false,
      staffDialog: false,
      assetDialog: false,
      firmDialog: false,
      currentIncome: null,
      currentStaff: null,
      currentAsset: null,
      currentFirm: null,
      currentAccountNumber: null,
      amount: 0.0,
      totalIncomeAmount: 0.0,
      totalStaffAmount: 0.0,
      totalAssetAmount: 0.0,
      // buyerById: {},
      currentAccountNumber: "",
      currentAccountKey: "",
      currentFirm: "",
      assetRate: [],
      debitNoteCount: 0,
      creditNoteCount: 0,
      topCustomers: [],
      Sec3DetailsDialog: false,
      Sec3Type: null,
      bookExpansion: false,
      gstrExpansion: false,
      otherAcctExpansion: false,
      depositExpansion: false,
      search : null,
      searchCustomer : null
    };
  },
  created() {
    this.$bindAsArray("firms", this.$root.$firebaseRefs.firm.orderByChild('brand').equalTo(brand));
    this.$bindAsArray("accounts", this.$root.$firebaseRefs.account.orderByChild('brand').equalTo(brand));
    this.$bindAsArray("buyers", this.$root.$firebaseRefs.buyer.orderByChild('brand').equalTo(brand));
    this.$bindAsArray("sellers", this.$root.$firebaseRefs.seller.orderByChild('brand').equalTo(brand));
    this.$bindAsObject("buyerById", this.$root.$firebaseRefs.buyer.orderByChild('brand').equalTo(brand));
    this.$bindAsObject("sellerById", this.$root.$firebaseRefs.seller.orderByChild('brand').equalTo(brand));
    this.$bindAsArray("items", this.$root.$firebaseRefs.item.orderByChild('brand').equalTo(brand));
    this.$bindAsArray("invoices", this.$root.$firebaseRefs.invoice.orderByChild('brand').equalTo(brand));
    this.$bindAsArray("expenses", this.$root.$firebaseRefs.expenses.orderByChild('brand').equalTo(brand));
    this.$bindAsArray("liabilities", this.$root.$firebaseRefs.liabilities.orderByChild('brand').equalTo(brand));
    this.$bindAsArray("incomes", this.$root.$firebaseRefs.incomes.orderByChild('brand').equalTo(brand));
    this.$bindAsArray("staffs", this.$root.$firebaseRefs.staff.orderByChild('brand').equalTo(brand));
    this.$bindAsArray("assets", this.$root.$firebaseRefs.assets.orderByChild('brand').equalTo(brand));
    this.$bindAsArray("assetRate", this.$root.$firebaseRefs.rate.orderByChild('brand').equalTo(brand));
    this.$bindAsArray("products", this.$root.$firebaseRefs.products.orderByChild('brand').equalTo(brand));
    this.$bindAsArray("termsAndConditions", this.$root.$firebaseRefs.termsAndConditions.orderByChild('brand').equalTo(brand));
    this.$bindAsArray("firmSettings", this.$root.$firebaseRefs.firmSettings.orderByChild('brand').equalTo(brand));
    let today = new Date()
    this.date = `${today.getFullYear()}-${today.getMonth()+1}-${today.getDate()}`
    // this.fromDate = `${today.getFullYear()}-${today.getMonth()+1}-${today.getDate()}`
    // this.toDate = `${today.getFullYear()}-${today.getMonth()+1}-${today.getDate()}`  
  },

  mounted() {
    this.updateWidgets();
    this._keyListener = function(e) {
            if (event.altKey && event.key === 'F1') {
                e.preventDefault();
                console.log('Sale Register [Reports]');
                this.$router.push({ path: `/sale-register` });
            }
            else if (event.altKey && event.key === 'F2') {
                e.preventDefault();
                console.log('Purchase Register [Reports]');
                this.$router.push({ path: `/purchase-register` });
            }
            else if (event.altKey && event.key === 'F3') {
                e.preventDefault();
                console.log('Stock Register [Reports]');
                this.$router.push({ path: `/reports/stock` });
            }
            else if (event.altKey && event.key == 'F5') {
                e.preventDefault();
                this.$router.push({ path: `/informations/bsheet` });
                console.log('Balance Sheet');
            }
            else if (event.altKey && event.key == 'F6') {
                e.preventDefault();
                this.$router.push({ path: `/informations/tradingaccount` });
                console.log('Trading account');
            }
            else if (event.altKey && event.key == 'F7') {
                e.preventDefault();
                this.$router.push({ path: `/informations/profitandloss` });
                console.log('Profit and loss Account');
            }
            else if (event.altKey && event.key == 'F8') {
                e.preventDefault();
                this.$router.push({ path: `/informations/proprietor` });
                console.log('Capital Account');
            }
            else if (event.altKey && event.key == 'F9') {
                e.preventDefault();
                this.$router.push({ path: `/informations/trail-balance-accounts` });
                console.log('Trail Balance');
            }
            else if (event.altKey && event.key == 'F10') {
                e.preventDefault();
                this.$router.push({ path: `/informations/cashaccount` });
                console.log('Cash Book');
            }
            else if (event.altKey && event.key === '1') {
                e.preventDefault();
                console.log('GSTR 1');
                this.$router.push({ path: `/gst1-reports` });
            }
            else if (event.altKey && event.key === '3') {
                e.preventDefault();
                console.log('GSTR 3');
                  this.$router.push({ path: `/gst3-reports` });
            }
            
            else if (event.altKey && event.key == 'a') {
                e.preventDefault();
                this.$router.push({ path: `/Dashboard` });
                console.log('Dashboard');
            }
            else if (event.altKey && event.key == 'b') {
                e.preventDefault();
                this.$router.push({ path: `/buyers` });
                console.log('Buyers');
            }
            else if (event.altKey && event.key == 'c') {
                e.preventDefault();
                this.$router.push({ path: `/informations/collection-book` });
                console.log('Collection Book');
            }
            else if (event.altKey && event.key == 'd') {
                e.preventDefault();
                this.$router.push({ path: `/daily-transaction-book` });
                console.log('Day Book');
            }
            else if (event.altKey && event.key == 'e') {
                e.preventDefault();
                this.$router.push({ path: `/recordEstimate` });
                console.log('Estimate');
            }
            else if (event.altKey && event.key == 'f') {
                e.preventDefault();
                this.$router.push({ path: `/informations` });
                console.log('financial Reports');
            }
            else if (event.altKey && event.key == 'g') {
                e.preventDefault();
                this.$router.push({ path: `/godawn` });
                console.log('Godawns');
            }
            else if (event.altKey && event.key == 'h') {
                e.preventDefault();
                this.$router.push({ path: `/godawn` });
                console.log('Godawns');
            }
            else if (event.altKey && event.key == 'i') {
                e.preventDefault();
                this.$router.push({ path: `/quick-invoice` });
                console.log('New Invoice');
            }
            else if (event.altKey && event.key == 'j') {
                e.preventDefault();
                this.$router.push({ path: `/godawn` });
                console.log('Godawns');
            }
            else if (event.altKey && event.key == 'k') {
                e.preventDefault();
                this.$router.push({ path: `/godawn` });
                console.log('Godawns');
            }
            else if (event.altKey && event.key == 'l') {
                e.preventDefault();
                this.$router.push({ path: `/godawn` });
                console.log('Godawns');
            }
            else if (event.altKey && event.key == 'm') {
                e.preventDefault();
                this.$router.push({ path: `/godawn` });
                console.log('Godawns');
            }
            else if (event.altKey && event.key == 'n') {
                e.preventDefault();
                this.$router.push({ path: `/godawn` });
                console.log('Godawns');
            }
            else if (event.altKey && event.key == 'o') {
                e.preventDefault();
                this.$router.push({ path: `/recordOrder` });
                console.log('Manage Order');
            }
            else if (event.altKey && event.key == 'p') {
                e.preventDefault();
                this.$router.push({ path: `/products/true` });
                console.log('New Product');
            }
            
            
            else if (event.altKey && event.key == 'q') {
                e.preventDefault();
                this.$router.push({ path: `/quick-invoice` });
                console.log(' Quick Invoice ');
            }
            else if (event.altKey && event.key == 'r') {
                e.preventDefault();
                this.$router.push({ path: `/customer-payments/null` });
                console.log('Payments');
            }
            else if (event.altKey && event.key == 's') {
                e.preventDefault();
                this.$router.push({ path: `/settings` });
                console.log('Setting');
            }
            else if (event.altKey && event.key == 't') {
                e.preventDefault();
                this.$router.push({ path: `/transfer` });
                console.log('Transaction');
            }
            else if (event.altKey && event.key == 'u') {
                e.preventDefault();
                this.$router.push({ path: `/settings/account/true` });
                console.log('New Account');
            }
            else if (event.altKey && event.key == 'v') {
                e.preventDefault();
                this.$router.push({ path: `/invoicemanagement` });
                console.log('Invoice Management');
            }
            else if (event.altKey && event.key == 'w') {
                e.preventDefault();
                this.$router.push({ path: `/buyers` });
                console.log('Buyer');
            }
            else if (event.altKey && event.key == 'x') {
                e.preventDefault();
                this.$router.push({ path: `/invoicemanagement` });
                console.log('Transaction');
            }
            else if (event.altKey && event.key == 'y') {
                e.preventDefault();
                this.$router.push({ path: `/buyers` });
                console.log('Buyer');
            }
            else if (event.altKey && event.key == 'z') {
                e.preventDefault();
                this.$router.push({ path: `/reports` });
                console.log('Transaction');
            }
        };
        document.addEventListener('keydown', this._keyListener.bind(this));
  },
  beforeDestroy() {
      document.removeEventListener('keydown', this._keyListener);
  },
  computed: {
    ...mapGlobalGetters(["selectedBrand", "finYear","brandFinYear"]),
    firmStockReportType(){
        let val = 'APP'
        if(this.selectedFirm) {
          let dfirmSetting = this.firmSettings.filter(item => item['firm'] == this.selectedFirm)[0];
          if(dfirmSetting && dfirmSetting.stockReportView) {
            val = dfirmSetting.stockReportView
          }
        }
        return val;
      },
      closingStock() {
      let toDate = this.toDate ?  new Date(this.toDate).getTime() : null;
      let fromDate = this.fromDate ? new Date(this.fromDate).getTime() : null;
      let products = this.products.filter(item => (item['brand'] === this.selectedBrand &&
      (this.selectedFirm ? item['firm'] === this.selectedFirm : true)));
      let total = {
        quantity : 0,
        durationQuantity : 0,
        durationAmount : 0,
        saleQuantity : 0,
        durationQtySale : 0,
        durationAmountSale : 0,
        purchaseQuantity : 0,
        durationQtyPurchase : 0,
        durationAmountPurchase : 0,
        openingQuantity : 0,
        openingBalance : 0
      }
      products.map(p => {
        p["durationQuantity"] = undefined;
        p["durationAmount"] = 0;
        p["durationQtySale"] = 0;
        p["durationQtyPurchase"] = 0;
        p["durationAmountSale"] = 0;
        p["durationAmountPurchase"] = 0;
        p["stockReportData"] = {
        saleDetails : [],
        purchaseDetails : [],
        lastSalePrice : 0,
          lastPurchasePrice : 0
        } 
        if(p.openingBalance && p.openingQuantity) {
          p["stockReportData"]['purchaseDetails'].push({
            quantity : Number.parseFloat(p.openingQuantity),
            rate : (Number.parseFloat(p.openingBalance)/ Number.parseInt(p.openingQuantity)),
            date: p.openingDate
          })
          p["stockReportData"]['lastPurchasePrice'] = p.openingBalance;
        }
        total.openingQuantity += parseInt(p["openingQuantity"] ? p["openingQuantity"] : 0)
        total.openingBalance +=  Number.parseFloat(p["openingBalance"] ? p["openingBalance"] : 0)
      });
      let productGroup = products.reduce(function(r, a) {
        r[a[".key"]] = r[a[".key"]] || [];
        r[a[".key"]].push(a);
        return r;
      }, Object.create(null));
      let latestSaleDate = new Date('01-01-1000').getTime();
      let latestPurchaseDate = new Date('01-01-1000').getTime();
      let filteredInvoices = this.invoices.filter(item => (      
      (item.type != "automatic invoice") &&
      (item.items && item.items.length) &&
      (item.date >= this.finYear.start) && 
      (item.deleted != true) &&
      (item.date <= this.finYear.end) &&
      (this.selectedFirm ? item['firm'] === this.selectedFirm : true) &&
      (fromDate ? item.date >= fromDate : true) &&
      (toDate ? item.date <= toDate : true)));
      this.selectProdList = [];
      filteredInvoices.map(invoice => {
        let invoiceMonth = new Date(invoice.date).getMonth();
          let isBuyer = invoice.isBuyer;
          invoice.items &&
            invoice.items.map(item => {
              if(productGroup[item["productId"]]) {
                 if (
                productGroup[item["productId"]][0].durationQuantity != undefined
              ) {
                let durationQuantity = parseInt(
                  productGroup[item["productId"]][0]["durationQuantity"]
                );
                durationQuantity += !!isBuyer
                  ? -parseInt(item.quantity)
                  : parseInt(item.quantity);
                total.durationQuantity += durationQuantity;
                productGroup[item["productId"]][0][
                  "durationQuantity"
                ] = durationQuantity;
              } else {
                productGroup[item["productId"]][0][
                  "durationQuantity"
                ] = productGroup[item["productId"]][0].openingQuantity
                  ? productGroup[item["productId"]][0].openingQuantity
                  : 0;
                  total.durationQuantity += parseInt(productGroup[item["productId"]][0][
                  "durationQuantity"
                ]);
              }
              let rate = (Number.parseFloat(item.rate));
              if(isBuyer) {
                if(invoice.date > latestSaleDate) {
                  latestSaleDate = invoice.date;
                  productGroup[item["productId"]][0]['stockReportData']['lastSalePrice'] = rate;
                }
                productGroup[item["productId"]][0]['stockReportData']['saleDetails'].push({
                  quantity : item.quantity,
                  rate : rate,
                  date : invoice.date
                })
              } else {
                if(invoice.date > latestPurchaseDate) {
                  latestPurchaseDate = invoice.date;
                  productGroup[item["productId"]][0]['stockReportData']['lastPurchasePrice'] = rate;
                }
                productGroup[item["productId"]][0]['stockReportData']['purchaseDetails'].push({
                  quantity : item.quantity,
                  rate : rate,
                  date : invoice.date
                })
              }
             
              productGroup[item["productId"]][0]["durationAmount"] += !!isBuyer
                ? -Number.parseFloat(item.basicPrice) + Number.parseFloat(item.GSTValue)
                : Number.parseFloat(item.basicPrice) + Number.parseFloat(item.GSTValue);
                total.durationAmount += productGroup[item["productId"]][0]["durationAmount"];
              if (!!isBuyer) {
                productGroup[item["productId"]][0][
                  "durationQtySale"
                ] += parseInt(item.quantity);
                total.durationQtySale += parseInt(item.quantity);
                productGroup[item["productId"]][0][
                  "durationAmountSale"
                ] += (Number.parseFloat(item.basicPrice) + Number.parseFloat(item.GSTValue));
                total.durationAmountSale += Number.parseFloat(item.basicPrice) + Number.parseFloat(item.GSTValue);
              } else {
                productGroup[item["productId"]][0][
                  "durationQtyPurchase"
                ] += parseInt(item.quantity);
                total.durationQtyPurchase += parseInt(item.quantity);
                productGroup[item["productId"]][0][
                  "durationAmountPurchase"
                ] += Number.parseFloat(item.basicPrice) + Number.parseFloat(item.GSTValue);
                total.durationAmountPurchase += Number.parseFloat(item.basicPrice) + Number.parseFloat(item.GSTValue);
              }
              item['date'] = invoice.date;
              item['invoice'] = invoice;
              item['isBuyer'] = invoice['isBuyer'];
              item['openingBalance'] = productGroup[item["productId"]][0]['openingBalance']
              item['openingQuantity'] = productGroup[item["productId"]][0]['openingQuantity']
              if(!(productGroup[item["productId"]][0]['productList'] && productGroup[item["productId"]][0]['productList'].length))
                productGroup[item["productId"]][0]['productList'] = [];

              productGroup[item["productId"]][0]['productList'].push(item)
              }
              
            });
      });
      this.totalclosingStock = 0;
      let results = [];
      let closingStock = 0;
      Object.keys(productGroup).length &&
        Object.keys(productGroup).map((key, index)=> {
          productGroup[key][".key"] = key;
          results.push(productGroup[key][0]);
          productGroup[key][0]['closingAmount'] = this.getClosingAmount(productGroup[key][0]);
          let closingStockVal = Number.parseFloat(productGroup[key][0]['closingAmount'])
          closingStock += isNaN(closingStockVal) ? 0 : closingStockVal;
          productGroup[key][0]['closingQuantity'] = (parseInt(productGroup[key][0]['openingQuantity'] ?  productGroup[key][0]['openingQuantity'] : 0) + parseInt(productGroup[key][0]['durationQtyPurchase'] ?  productGroup[key][0]['durationQtyPurchase'] : 0)) - parseInt( productGroup[key][0]['durationQtySale'] ?  productGroup[key][0]['durationQtySale'] : 0)
          this.totalclosingStock += isNaN(productGroup[key][0]['closingQuantity']) ? 0 : productGroup[key][0]['closingQuantity'];
        });
      return closingStock;
    },
    firmsByBrand() {
      return this.firms
        .filter(item => item["brand"] === this.selectedBrand)
        .map(item => {
          if (item.defaultFirm) {
            this.selectedFirm = item['.key'];
          }
          return {
            text: item["name"],
            value: item[".key"]
          };
      });
    },

    itemList() {
      if (this.buyers && this.selectedBrand) {
        // return this.buyers.filter(item => item["brand"] === this.selectedBrand)
        // &&(!!this.search ? !!item["name"].toLowerCase().includes(this.search.toLowerCase()) : true)
        return this.buyers.filter(item => (item["brand"] === this.selectedBrand  && (!!this.searchCustomer ? !!item["name"].toLowerCase().includes(this.searchCustomer.toLowerCase()) : true)))
      }
    },
    
    getFirms() {
      if (this.firms && this.selectedBrand) {
        return this.firms.filter(item => item["brand"] === this.selectedBrand);
      }
    },
    getFirmSorted(){
      let firms = this.getFirms
      return firms.sort(function(a, b){
          var nameA=a.name.toLowerCase(), nameB=b.name.toLowerCase()
          if (nameA < nameB) //sort string ascending
              return -1 
          if (nameA > nameB)
              return 1
          return 0 //default return value (no sorting)
      })
    },

    getSortedBankAccounts() {
      if (this.accounts && this.selectedBrand) {
        return this.accounts.filter(
          item => item["brand"] === this.selectedBrand
        );
      }
    },

    getSorted(){
      let accounts = this.getAccounts
      return accounts.sort(function(a, b){
          var nameA=a.name.toLowerCase(), nameB=b.name.toLowerCase()
          if (nameA < nameB) //sort string ascending
              return -1 
          if (nameA > nameB)
              return 1
          return 0 //default return value (no sorting)
      })
    },

    getLoanAccount() {
      if (this.loan && this.selectedBrand) {
        return this.loan.filter(item => item["brand"] === this.selectedBrand);
      }
    },
    getLoanAdvancesAccount() {
      if (this.loanadvances && this.selectedBrand) {
        return this.loanadvances.filter(
          item => item["brand"] === this.selectedBrand
        );
      }
    },
    getAssetAccount() {
      if (this.asset && this.selectedBrand) {
        return this.asset.filter(item => item["brand"] === this.selectedBrand);
      }
    },
    getExpenses() {
      if (this.firms && this.selectedBrand) {
        return this.expenses.filter(
          item => item["brand"] === this.selectedBrand
        );
      }
    },
    getStaffs() {
      if (this.firms && this.selectedBrand) {
        return this.staffs.filter(item => item["brand"] === this.selectedBrand);
      }
    },
    getAssets() {
      if (this.firms && this.selectedBrand) {
        return this.assets.filter(item => item["brand"] === this.selectedBrand);
      }
    },
    getIncomes() {
      if (this.firms && this.selectedBrand) {
        return this.incomes.filter(
          item => item["brand"] === this.selectedBrand
        );
      }
    },
    itemListCount() {
      return this.buyers.filter(item => item["brand"] === this.selectedBrand)
        .length;
    },
    totalSeller() {
      return this.sellers.filter(item => item["brand"] === this.selectedBrand)
        .length;
    },
    getItemsCount() {
      return this.items.filter(item => item["brand"] === this.selectedBrand)
        .length;
    },
    getInvoices() {
      if(this.selectedBrand) {
      let toDate = this.toDate ?  new Date(this.toDate).getTime() : null;
      let fromDate = this.fromDate ? new Date(this.fromDate).getTime() : null;
      let filteredInvoice = this.invoices.filter(
        // item => item["brand"] === this.selectedBrand
        item => (item["brand"] === this.selectedBrand && 
        (item.deleted != true) &&
        (item.date >= this.finYear.start) && (item.date <= this.finYear.end) &&
        (this.selectedFirm? item.firm === this.selectedFirm : true) &&
        (fromDate ? item.date >= fromDate : true) &&
        (toDate ? item.date <= toDate : true))
      );

      let totalSales = 0.0;
      let totalPurchase = 0.0;
      let totalCreditNote = 0.0;
      let totalDebitNote = 0.0;
      let buyerTotalColumn = {
        totalColumn_buyer: true,
        paidAmount: 0,
        remainingAmount: 0,
        totalAmount: 0,
        basicAmount: 0,
        discountAmount: 0,
        gstTotal: 0,
        GST_3: 0,
        GST_5: 0,
        GST_12: 0,
        GST_18: 0,
        GST_28: 0
      };
      let debitTotalColumn = {
        totalColum_debit: true,
        paidAmount: 0,
        remainingAmount: 0,
        totalAmount: 0,
        basicAmount: 0,
        discountAmount: 0,
        gstTotal: 0,
        GST_3: 0,
        GST_5: 0,
        GST_12: 0,
        GST_18: 0,
        GST_28: 0
      };
      let sellerTotalColumn = {
        totalColum_seller: true,
        paidAmount: 0,
        remainingAmount: 0,
        totalAmount: 0,
        basicAmount: 0,
        discountAmount: 0,
        gstTotal: 0,
        GST_3: 0,
        GST_5: 0,
        GST_12: 0,
        GST_18: 0,
        GST_28: 0
      };
      let creditTotalColumn = {
        totalColum_credit: true,
        paidAmount: 0,
        remainingAmount: 0,
        totalAmount: 0,
        basicAmount: 0,
        discountAmount: 0,
        gstTotal: 0,
        GST_3: 0,
        GST_5: 0,
        GST_12: 0,
        GST_18: 0,
        GST_28: 0
      };
      this.creditNoteCount = 0;
      this.debitNoteCount = 0;
      this.topCustomers = [];
      this.tradeData = [
        {
          name: "Sale",
          data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
        },
        {
          name: "Purchase",
          data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
        }
      ];

      this.volumeData = [
        {
          name: "Credit",
          data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
        },
        {
          name: "Debit",
          data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
        }
      ];

      let date = new Date();
      var firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
      var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);

      this.volumeOptionsDaily.xaxis.categories = this.getDates(firstDay,lastDay);
      firstDay = firstDay.getTime();
      lastDay = lastDay.getTime();
       this.volumeDataDaily[0]['data'] = [];
       this.volumeDataDaily[1]['data'] = [];
      this.volumeOptionsDaily.xaxis.categories.map(i => this.volumeDataDaily[0]['data'].push(0),this.volumeDataDaily[1]['data'].push(0));
      console.log(this.volumeOptionsDaily.xaxis.categories);
      filteredInvoice.map((item, index) => {
        let customer = null;
        let monthAdder = new Date(item.date).getMonth() < 3 ? 9 : -3;
        // let yearToFetch = new Date(item.date).getMonth() < 3 ? (new Date().getFullYear()+1) : new Date().getFullYear();
        let yearToFetchFrom = new Date(this.finYear.start).getFullYear()
        let yearToFetchTo = new Date(this.finYear.end).getFullYear()
        let itemYear = new Date(item.date).getFullYear()

        if(item.date >= firstDay && item.date <= lastDay) {
          if(item["isBuyer"]) {
            this.volumeDataDaily[0]['data'][new Date(item.date).getDate() - 1] += Number.parseInt(item["totalAmount"]) > 0
                ? Number.parseFloat(item["totalAmount"])
                : 0;
          } else {
            this.volumeDataDaily[1]['data'][new Date(item.date).getDate() - 1] += Number.parseInt(item["totalAmount"]) > 0
                ? Number.parseFloat(item["totalAmount"])
                : 0;
          }
        }


        if (item["isBuyer"] === true && (['All', 'Customers'].includes(this.topCustomerFilter))) {
          if (itemYear == yearToFetchFrom || itemYear == yearToFetchTo) {
            // this.tradeData[0]["data"][new Date(item.date).getMonth()] +=
            this.tradeData[0]["data"][(new Date(item.date).getMonth()+monthAdder)] +=
              Number.parseInt(item["totalAmount"]) > 0
                ? Number.parseFloat(item["totalAmount"])
                : 0;
            //  this.tradeData[0]['data'][new Date(item.date).getMonth()] = Number.parseFloat(this.tradeData[0]['data'][new Date(item.date).getMonth()]).toFixed(2);
          }

          if (
            (itemYear == yearToFetchFrom || itemYear == yearToFetchTo) &&
            item.status == "paid"
          ) {
            // this.volumeData[0]["data"][new Date(item.date).getMonth()] +=
            this.volumeData[0]["data"][(new Date(item.date).getMonth()+monthAdder)] +=
            Number.parseInt(item["totalAmount"]) > 0
                ? Number.parseFloat(item["totalAmount"])
                : 0;
            //  this.volumeData[0]['data'][new Date(item.date).getMonth()] = Number.parseFloat(this.volumeData[0]['data'][new Date(item.date).getMonth()]).toFixed(2);
          }

          if (
            (itemYear == yearToFetchFrom || itemYear == yearToFetchTo)&&
            item.status == "partial"
          ) {
            // this.volumeData[0]["data"][new Date(item.date).getMonth()] +=
            this.volumeData[0]["data"][(new Date(item.date).getMonth()+monthAdder)] +=

            Number.parseInt(item["paidAmount"]) > 0
                ? Number.parseFloat(item["paidAmount"])
                : 0;
            //this.volumeData[0]['data'][new Date(item.date).getMonth()] = Number.parseFloat(this.volumeData[0]['data'][new Date(item.date).getMonth()]).toFixed(2);
          }
          let index = this.topCustomers.findIndex(
            e => e["idOfBuyer"] == item.buyerId
          );
          if (index != -1) {
            this.topCustomers[index]["totalAmount"] +=
              Number.parseInt(item["totalAmount"]) > 0
                ? Number.parseFloat(item["totalAmount"])
                : 0;
            this.topCustomers[index]["paidAmount"] +=
              Number.parseInt(item["paidAmount"]) > 0
                ? Number.parseFloat(item["paidAmount"])
                : 0;
            this.topCustomers[index]["remainingAmount"] +=
              Number.parseInt(item["remainingAmount"]) > 0
                ? Number.parseFloat(item["remainingAmount"])
                : 0;
            // this.topCustomers[index]["totalAmount"] = Number.parseFloat(
            //   this.topCustomers[index]["totalAmount"]
            // ).toFixed(2);
            // this.topCustomers[index]["paidAmount"] = Number.parseFloat(
            //   this.topCustomers[index]["paidAmount"]
            // ).toFixed(2);
            // this.topCustomers[index]["remainingAmount"] = Number.parseFloat(
            //   this.topCustomers[index]["remainingAmount"]
            // ).toFixed(2);
          } else {
            customer = this.buyerById[item.buyerId];
            if(customer) {
              customer["totalAmount"] = Number.parseFloat(item['totalAmount']);
              customer["idOfBuyer"] = item.buyerId;
              customer["paidAmount"] = Number.parseFloat(item['paidAmount']);
              customer["remainingAmount"] = Number.parseFloat(item['remainingAmount']);
              this.topCustomers.push(customer);
            }
          }
        } else if (item["isBuyer"] === false  && (['All', 'Suppliers'].includes(this.topCustomerFilter))) {
          if (itemYear == yearToFetchFrom || itemYear == yearToFetchTo) {
            // this.tradeData[1]["data"][new Date(item.date).getMonth()] +=
            this.tradeData[1]["data"][(new Date(item.date).getMonth()+monthAdder)] +=

            Number.parseInt(item["totalAmount"]) > 0
                ? Number.parseFloat(item["totalAmount"])
                : 0;
            //this.tradeData[1]['data'][new Date(item.date).getMonth()] = Number.parseFloat(this.tradeData[0]['data'][new Date(item.date).getMonth()]).toFixed(2);
          }
          if (
            (itemYear == yearToFetchFrom || itemYear == yearToFetchTo) &&
            item.status == "paid"
          ) {
            // this.volumeData[1]["data"][new Date(item.date).getMonth()] +=
            this.volumeData[1]["data"][(new Date(item.date).getMonth()+monthAdder)] +=

            Number.parseInt(item["totalAmount"]) > 0
                ? Number.parseFloat(item["totalAmount"])
                : 0;
            //this.volumeData[1]['data'][new Date(item.date).getMonth()] = Number.parseFloat(this.volumeData[0]['data'][new Date(item.date).getMonth()]).toFixed(2);
          }
          if (
            (itemYear == yearToFetchFrom || itemYear == yearToFetchTo) &&
            item.status == "partial"
          ) {
            // this.volumeData[1]["data"][new Date(item.date).getMonth()] +=
            this.volumeData[1]["data"][(new Date(item.date).getMonth()+monthAdder)] +=

            Number.parseInt(item["paidAmount"]) > 0
                ? Number.parseFloat(item["paidAmount"])
                : 0;
            //this.volumeData[1]['data'][new Date(item.date).getMonth()] = Number.parseFloat(this.volumeData[0]['data'][new Date(item.date).getMonth()]).toFixed(2);
          }
          let index = this.topCustomers.findIndex(
            e => e["idOfBuyer"] == item.buyerId
          );
          if (index != -1) {
            this.topCustomers[index]["totalAmount"] +=
              Number.parseInt(item["totalAmount"]) > 0
                ? Number.parseFloat(item["totalAmount"])
                : 0;
            this.topCustomers[index]["paidAmount"] +=
              Number.parseInt(item["paidAmount"]) > 0
                ? Number.parseFloat(item["paidAmount"])
                : 0;
            this.topCustomers[index]["remainingAmount"] +=
              Number.parseInt(item["remainingAmount"]) > 0
                ? Number.parseFloat(item["remainingAmount"])
                : 0;
            // this.topCustomers[index]["totalAmount"] = Number.parseFloat(
            //   this.topCustomers[index]["totalAmount"]
            // ).toFixed(2);
            // this.topCustomers[index]["paidAmount"] = Number.parseFloat(
            //   this.topCustomers[index]["paidAmount"]
            // ).toFixed(2);
            // this.topCustomers[index]["remainingAmount"] = Number.parseFloat(
            //   this.topCustomers[index]["remainingAmount"]
            // ).toFixed(2);
          } else {
            customer = this.sellerById[item.buyerId];
             if(customer) {
              customer["totalAmount"] = Number.parseFloat(item['totalAmount']);
              customer["idOfBuyer"] = item.buyerId;
              customer["paidAmount"] = Number.parseFloat(item['paidAmount']);
              customer["remainingAmount"] = Number.parseFloat(item['remainingAmount']);
              this.topCustomers.push(customer);
            }
          }
        }
        if (item["items"] && item["items"].length)
          filteredInvoice[index][
            "GST_Percentage_total"
          ] = getGSTPercentageTotal(item["items"]);
        else {
          filteredInvoice[index]["GST_Percentage_total"] = {
            GST_3: 0,
            GST_5: 0,
            GST_12: 0,
            GST_18: 0,
            GST_28: 0
          };
        }
        totalSales =
          totalSales +
          (item["isBuyer"] === true ? Number.parseFloat(item.totalAmount) : 0);
        totalPurchase =
          totalPurchase +
          (item["isBuyer"] === false ? Number.parseFloat(item.totalAmount) : 0);
        if (item["return"] == true) {
          totalCreditNote =
            totalCreditNote +
            (item["isBuyer"] === true
              ? Number.parseFloat(item.totalAmount)
              : 0);
          this.creditNoteCount += item["isBuyer"] === true ? 1 : 0;

          totalDebitNote =
            totalDebitNote +
            (item["isBuyer"] === false
              ? Number.parseFloat(item.totalAmount)
              : 0);
          this.debitNoteCount += item["isBuyer"] === false ? 1 : 0;
        }
        if (item.isBuyer === true && !item.return) {
          buyerTotalColumn = this.getTotalColumn(item, buyerTotalColumn);
        }
        if (item.isBuyer === true && item.return) {
          creditTotalColumn = this.getTotalColumn(item, creditTotalColumn);
        }
        if (item.isBuyer === false && item.return) {
          debitTotalColumn = this.getTotalColumn(item, debitTotalColumn);
        }
        if (item.isBuyer === false && !item.return) {
          sellerTotalColumn = this.getTotalColumn(item, sellerTotalColumn);
        }
      });

      this.tradeData[0].data.map((data, index) => {
        this.tradeData[0].data[index] = Number.parseFloat(data).toFixed(2);
      });

      this.tradeData[1].data.map((data, index) => {
        this.tradeData[1].data[index] = Number.parseFloat(data).toFixed(2);
      });

      this.volumeData[0].data.map((data, index) => {
        this.volumeData[0].data[index] = Number.parseFloat(data).toFixed(2);
      });

      this.volumeData[1].data.map((data, index) => {
        this.volumeData[1].data[index] = Number.parseFloat(data).toFixed(2);
      });

      this.topCustomers.sort((a, b) =>
        a.totalAmount < b.totalAmount
          ? 1
          : b.totalAmount < a.totalAmount
          ? -1
          : 0
      );
      this.totalSales = Number.parseFloat(totalSales).toFixed(2);
      this.totalPurchase = Number.parseFloat(totalPurchase).toFixed(2);
      this.totalCreditNote = Number.parseFloat(totalCreditNote).toFixed(2);
      this.totalDebitNote = Number.parseFloat(totalDebitNote).toFixed(2);
      this.updateWidgets();
      filteredInvoice.push(buyerTotalColumn);
      filteredInvoice.push(creditTotalColumn);
      filteredInvoice.push(debitTotalColumn);
      filteredInvoice.push(sellerTotalColumn);

      let firms = this.firms.filter(
        item => item["brand"] === this.selectedBrand
      );
      firms.map(item => {
        let inv = {};
        if (!!item.openingBalance) {
          inv["firm"] = item[".key"];
          inv["totalAmount"] = item["openingBalance"];
          inv["isCredited"] = true;
          inv["remark"] = "Opening Balance";
          inv["date"] = item["openingDate"];
        }
        filteredInvoice.push(inv);

        if(!!item.amountAtCreation) {
          inv["firm"] = item[".key"];
          inv["totalAmount"] = item["amountAtCreation"];
          inv["isCredited"] = true;
          inv["remark"] = "Opening Amount";
          inv["paymentType"] = "Cash"
          inv["date"] = item["openingDate"];
        }
      });

      let banks = this.accounts.filter(
        item => item["brand"] === this.selectedBrand
      );
      banks.map(item => {
        let inv = {};
        if (!!item.openingBalance) {
          inv["bank"] = item[".key"];
          inv["totalAmount"] = item["openingBalance"];
          inv["isCredited"] = true;
          inv["remark"] = "Opening Balance";
          inv["date"] = item["openingDate"];
          inv['accountType'] = item['accountType']
        }
        filteredInvoice.push(inv);
      });
      return filteredInvoice;
      } else {
        return [];
      }
    },
    getSaleInvoices() {
      let toDate = this.toDate ?  new Date(this.toDate).getTime() : null;
      let fromDate = this.fromDate ? new Date(this.fromDate).getTime() : null;
      return this.getInvoices.filter(item => {
        let saleOuted =
          (item.isBuyer === true && !item.return) || item.totalColumn_buyer;
        if (this.selectedFirm && saleOuted) {
          return (item.firm === this.selectedFirm  && (fromDate ? item.date >= fromDate : true) &&
          (toDate ? item.date <= toDate : true));
        }
        return saleOuted && ((this.selectedFirm ? item["firm"] == this.selectedFirm : true)
        && (fromDate ? item.date >= fromDate : true) &&
          (toDate ? item.date <= toDate : true)
        );
      });
    },
    getCreditNoteInvoices() {
      return this.getInvoices.filter(item => {
        // let creditNoteGenerator = (item.isBuyer === true  && (!item.return) || item.totalColumn_buyer)
        let creditNoteGenerator =
          (item.isBuyer === true && item.return) || item.totalColum_credit;
        if (this.selectedFirm && creditNoteGenerator) {
          return item.firm === this.selectedFirm;
        }
        return creditNoteGenerator;
      });
    },
    getDebitNoteInvoices() {
      return this.getInvoices.filter(item => {
        // let creditNoteGenerator = (item.isBuyer === true  && (!item.return) || item.totalColumn_buyer)
        let debitNoteGenerator =
          (item.isBuyer === false && item.return) || item.totalColum_debit;
        if (this.selectedFirm && debitNoteGenerator) {
          return item.firm === this.selectedFirm;
        }
        return debitNoteGenerator;
      });
    },
    getPurchaseInvoices() {
      let toDate = this.toDate ?  new Date(this.toDate).getTime() : null;
      let fromDate = this.fromDate ? new Date(this.fromDate).getTime() : null;
      return this.getInvoices.filter(item => {
        let purchaseOuted =
          (item.isBuyer === false && !item.return) || item.totalColum_seller;
        if (this.selectedFirm && purchaseOuted) {
          return (item.firm === this.selectedFirm && (fromDate ? item.date >= fromDate : true) &&
          (toDate ? item.date <= toDate : true));
        }
        return purchaseOuted && ((this.selectedFirm ? item["firm"] == this.selectedFirm : true)
        && (fromDate ? item.date >= fromDate : true) &&
          (toDate ? item.date <= toDate : true)
        );
      });
    },
    getFirmInvoices() {
      let toDate = this.toDate ?  new Date(this.toDate).getTime() : null;
      let fromDate = this.fromDate ? new Date(this.fromDate).getTime() : null;
      // return this.getInvoices.filter( item => item.firm === this.currentFirmById
      let brokrageINV = [];
      this.getInvoices.map((invoice)=>{
        if(invoice.brokeragePaid) {
          let inv = JSON.parse(JSON.stringify(invoice))
          inv['isCredited'] = false;
          inv['totalAmount'] = ((Number.parseFloat(inv.totalAmount) * Number.parseFloat(inv.brokerageRate))/100);
          inv['discountAmount'] = 0;
          inv['date'] = inv['brokeragePayDate'];
          inv['brokrageInvoice'] = true;
          brokrageINV.push(inv)
        }
      });
      brokrageINV = brokrageINV.concat(this.getInvoices)
      return brokrageINV.filter( item => item.firm === this.currentFirmById
      && (this.selectedFirm ? item["firm"] == this.selectedFirm : true)
        && (fromDate ? item.date >= fromDate : true) 
        && (toDate ? item.date <= toDate : true)
      );
    },
    getCashInvoices() {
      let toDate = this.toDate ?  new Date(this.toDate).getTime() : null;
      let fromDate = this.fromDate ? new Date(this.fromDate).getTime() : null;
      
      return this.getInvoices.filter(
        item => (item.firm === this.currentFirmById
        &&["Cash","cash"].indexOf(item['paymentType']) > -1 
        && ((this.selectedFirm ? item["firm"] == this.selectedFirm : true)
        && (fromDate ? item.date >= fromDate : true) &&
          (toDate ? item.date <= toDate : true)
        )
      )
      ); 
    },
    currentFirmById() {
      if (this.currentFirm) {
        return this.getFirms.find(firm => firm.name === this.currentFirm)[
          ".key"
        ];
      }
      return null;
    },
    getBankInvoices() {
      let toDate = this.toDate ?  new Date(this.toDate).getTime() : null;
      let fromDate = this.fromDate ? new Date(this.fromDate).getTime() : null;
      return this.getInvoices.filter(
        item => (item.bank && item.bank === this.currentAccountKey
        && (this.selectedFirm ? item["firm"] == this.selectedFirm : true)
        && (fromDate ? item.date >= fromDate : true) &&
          (toDate ? item.date <= toDate : true)
        )
      );
    },
    getExpenseInvoices() {
      return this.getInvoices.filter(
        invoice => invoice.expenseType === this.currentExpense
      );
    },
    getIncomeInvoices() {
      return this.getInvoices.filter(
        invoice => invoice.incomeType === this.currentIncome
      );
    },
    getStaffInvoices() {
      return this.getInvoices.filter(
        invoice => invoice.staffkey === this.currentStaff
      );
    },
    getAssetInvoices() {
      return this.getInvoices.filter(
        invoice => invoice.assetType === this.currentAsset
      );
    },
    getPurchaseCount() {
      if(this.selectedBrand) {
      let toDate = this.toDate ?  new Date(this.toDate).getTime() : null;
      let fromDate = this.fromDate ? new Date(this.fromDate).getTime() : null;
      return this.invoices.filter(
        item =>
          ((item["brand"] === this.selectedBrand && item["isBuyer"] === false) &&
          (item.date >= this.finYear.start) && (item.date <= this.finYear.end) &&
          (this.selectedFirm? item.firm === this.selectedFirm : true) &&
          (item.deleted != true) &&
        (fromDate ? item.date >= fromDate : true) &&
        (toDate ? item.date <= toDate : true))
      ).length;
      } else {
        return 0;
      }
    },
    getSalesCount() {
      if(this.selectedBrand) {
        let toDate = this.toDate ?  new Date(this.toDate).getTime() : null;
        let fromDate = this.fromDate ? new Date(this.fromDate).getTime() : null;
        return this.invoices.filter(
          item => ((item["brand"] === this.selectedBrand && item["isBuyer"] === true) &&
          (item.date >= this.finYear.start) && (item.date <= this.finYear.end) &&
          (this.selectedFirm? item.firm === this.selectedFirm : true) &&
          (item.deleted != true) &&
          (fromDate ? item.date >= fromDate : true) &&
          (toDate ? item.date <= toDate : true))
        ).length;
      } else {
        return 0;
      }
    },
    getProductQuantity() {
      let productCount = 0;
      let products = this.products.filter(
        item => (item["brand"] === this.selectedBrand &&
      (this.selectedFirm? item.firm === this.selectedFirm : true)) 
      // &&(item.openingDate >= this.finYear.start) && (item.openingDate <= this.finYear.end))
      );
      products.map(prod => {
        productCount += Number.parseInt(prod.quantity);
      });
      return productCount;
    },
    getProductOpening() {
      let openingBal = 0;
      let products = this.products.filter(
        item => (item["brand"] === this.selectedBrand )
        // && (item.openingDate >= this.finYear.start) && (item.openingDate <= this.finYear.end))
      );
      products.map(prod => {
        openingBal += !!prod.openingBalance ? Number.parseInt(prod.openingBalance) : 0;
      });
      return openingBal;
    },
    getTopProducts() {
      let products = this.products.filter(
        item => (item["brand"] === this.selectedBrand &&
        (this.selectedFirm? item.firm === this.selectedFirm : true)) 
        // &&(item.openingDate >= this.finYear.start) && (item.openingDate <= this.finYear.end))
      );
      products.sort((a, b) =>
        a.saleQuantity < b.saleQuantity
          ? 1
          : b.saleQuantity < a.saleQuantity
          ? -1
          : 0
      );
      return products;
    },

    printPurchaseReport(){
      let purchaseInvoice = JSON.parse(JSON.stringify(this.getPurchaseInvoices));
      purchaseInvoice.map((item,index)=>{
        purchaseInvoice[index]["firmName"] = this.getFirmName(item.firm);
        purchaseInvoice[index]["buyerName"] = item.buyerId && this.sellerById[item.buyerId]  ? this.sellerById[item.buyerId].name : '';
        purchaseInvoice[index]["GST_TOTAL"] = this.getGSTtotal(item);
        purchaseInvoice[index]["BASIC_AMOUNT"] = (item.totalAmount - purchaseInvoice[index]["GST_TOTAL"] || 0);
        purchaseInvoice[index]["IGST"] = (item.gstType == 'IGST' ? purchaseInvoice[index]["GST_TOTAL"] : 0)
        purchaseInvoice[index]["CGST"] = (item.gstType == 'SGST|CGST' ? purchaseInvoice[index]["GST_TOTAL"]/2 : 0)
        purchaseInvoice[index]["SGST"] = (item.gstType == 'SGST|CGST' ? purchaseInvoice[index]["GST_TOTAL"]/2 : 0)
        purchaseInvoice[index]["GST_3"] = (item.GST_Percentage_total ? item['GST_Percentage_total']['GST_3'] : '')
        purchaseInvoice[index]["GST_5"] = (item.GST_Percentage_total ? item['GST_Percentage_total']['GST_5'] : '')
        purchaseInvoice[index]["GST_12"] = (item.GST_Percentage_total ? item['GST_Percentage_total']['GST_12'] : '')
        purchaseInvoice[index]["GST_18"] = (item.GST_Percentage_total ? item['GST_Percentage_total']['GST_18'] : '')
        purchaseInvoice[index]["GST_28"] = (item.GST_Percentage_total ? item['GST_Percentage_total']['GST_28'] : '')
      })
      let doc = convertToPDFReport({
        type:'Purchase Register',
        invoiceData:purchaseInvoice,
        firm:this.selectedFirm ? this.getFirmName(this.selectedFirm) : null,
        fromDate : this.fromDate ? new Date(this.fromDate).toLocaleDateString('en-GB') : null,
        toDate :  this.toDate ? new Date(this.toDate).toLocaleDateString('en-GB') : null,
      });
      pdfMake.createPdf(doc).download();
    },

    printSaleReport(){
      let saleInvoices = JSON.parse(JSON.stringify(this.getSaleInvoices));
      saleInvoices.map((item,index)=>{
        saleInvoices[index]["firmName"] = this.getFirmName(item.firm);
        saleInvoices[index]["buyerName"] = item.buyerId && this.buyerById[item.buyerId]  ? this.buyerById[item.buyerId].name : '';
        saleInvoices[index]["GST_TOTAL"] = this.getGSTtotal(item);
        saleInvoices[index]["BASIC_AMOUNT"] = (item.totalAmount - saleInvoices[index]["GST_TOTAL"] || 0);
        saleInvoices[index]["IGST"] = (item.gstType == 'IGST' ? saleInvoices[index]["GST_TOTAL"] : 0)
        saleInvoices[index]["CGST"] = (item.gstType == 'SGST|CGST' ? saleInvoices[index]["GST_TOTAL"]/2 : 0)
        saleInvoices[index]["SGST"] = (item.gstType == 'SGST|CGST' ? saleInvoices[index]["GST_TOTAL"]/2 : 0)
        saleInvoices[index]["GST_3"] = (item.GST_Percentage_total ? item['GST_Percentage_total']['GST_3'] : '')
        saleInvoices[index]["GST_5"] = (item.GST_Percentage_total ? item['GST_Percentage_total']['GST_5'] : '')
        saleInvoices[index]["GST_12"] = (item.GST_Percentage_total ? item['GST_Percentage_total']['GST_12'] : '')
        saleInvoices[index]["GST_18"] = (item.GST_Percentage_total ? item['GST_Percentage_total']['GST_18'] : '')
        saleInvoices[index]["GST_28"] = (item.GST_Percentage_total ? item['GST_Percentage_total']['GST_28'] : '')
      })
      let doc = convertToPDFReport({
        type:'Sale Register',
        invoiceData:saleInvoices,
        firm:this.selectedFirm ? this.getFirmName(this.selectedFirm) : null,
        fromDate : this.fromDate ? new Date(this.fromDate).toLocaleDateString('en-GB') : null,
        toDate :  this.toDate ? new Date(this.toDate).toLocaleDateString('en-GB') : null,
      });
      console.log(doc)
      pdfMake.createPdf(doc).download();
    },
  },
  watch: {
    isFilter(val) {
      if(val){
        document.getElementById("dashboard-filters").style.display = "";
      } else {
        document.getElementById("dashboard-filters").style.display = "none";
      }
    },
    buyer(val) {
      this.updateWidgets();
    },
    items(val) {
      this.updateWidgets();
    },
    invoices(val) {
      this.calculateProfitLoss();
      this.updateWidgets();
    },
    selectedBrand(val) {
      console.log("branch change detect")
      console.log(val)
      // document.querySelectorAll('.v-navigation-drawer div.v-list div[role="listitem"] a')[1].click()
      // setTimeout(()=>{
      //   document.querySelectorAll('.v-navigation-drawer div.v-list div[role="listitem"] a')[0].click()
      // })
      this.calculateProfitLoss();
      this.updateWidgets();
    }
  },
  methods: {
      getDates(startDate, stopDate) {
      Date.prototype.addDays = function(days) {
          var date = new Date(this.valueOf());
          date.setDate(date.getDate() + days);
          return date;
      }
        var dateArray = new Array();
        var currentDate = startDate;
        while (currentDate <= stopDate) {
            dateArray.push(new Date (currentDate).getDate());
              currentDate=  currentDate.addDays(1);
        }
        return dateArray;
    },
     getTranslatedHeaders(header){
      let header1 = [...header]
      header1.map((item,index)=>{
        header1[index]['text'] = i18n.t(header1[index]['text'])
      })
      return header1;
    },
    getClosingAmount(item) {
      let closingQty = (parseInt(item['openingQuantity'] ? item['openingQuantity'] : 0) + parseInt(item['durationQtyPurchase'] ? item['durationQtyPurchase'] : 0)) - parseInt(item['durationQtySale'] ? item['durationQtySale'] : 0)
      switch(this.firmStockReportType) {
        
        case 'APP' :{
          let amount = 0;
          if(item.stockReportData) {
          let avgPurchasePrice = (item.stockReportData.purchaseDetails.reduce((a, b) => a + (b['rate'] || 0), 0))/item.stockReportData.purchaseDetails.length;
          amount = (avgPurchasePrice * closingQty);
          }
          return amount;
        }
        case 'LPP' :{
          let amount = 0;
          if(item.stockReportData) {
            amount = (item.stockReportData.lastPurchasePrice * closingQty);
          }
          return amount;
        }
        case 'LSP' :{
          let amount = 0;
          if(item.stockReportData) {
            amount = (item.stockReportData.lastSalePrice * closingQty);
          }
          return amount;
        }
        case 'ASP' :{
          let amount = 0;
          if(item.stockReportData) {
            let avgSalePrice = (item.stockReportData.saleDetails.reduce((a, b) => a + (b['rate'] || 0), 0))/item.stockReportData.saleDetails.length;
            amount = (avgSalePrice * closingQty);
          }
          return amount;
        }
        case 'FIFO' :{
          let amount = 0;
          if(item.stockReportData) {
            let allTransaction = item.stockReportData.purchaseDetails.sort(function(a,b){
              return -(new Date(b.date) - new Date(a.date));
            });

            let qntTemp = closingQty;
            allTransaction.map((t)=>{
              if(qntTemp>t.quantity) {
                amount += (t.quantity * t.rate);
                qntTemp = qntTemp-t.quantity
              } else if(qntTemp > 0) {
                amount += (t.quantity-qntTemp * t.rate);
                qntTemp = 0;
              }
            })        
          }
          return amount;
        }
        case 'LIFO' :{
          let amount = 0;
          if(item.stockReportData) {
            let allTransaction = item.stockReportData.purchaseDetails.sort(function(a,b){
              return new Date(b.date) - new Date(a.date);
            });
            let qntTemp = closingQty;
            allTransaction.map((t)=>{
              if(qntTemp>t.quantity) {
                amount += (t.quantity * t.rate);
                qntTemp = qntTemp-t.quantity
              } else if(qntTemp > 0) {
                amount += (t.quantity-qntTemp * t.rate);
                qntTemp = 0;
              }
            })
          }
          return amount;
        }
      }
    },
    keymonitor(event){
      this.search = event.target.value;
    },
    keymonitorCustomer(event){
      this.searchCustomer = event.target.value;
    },
    dayDiff(d1){
      const date1 = new Date(d1);
      const date2 = new Date();
      const diffTime = Math.abs(date2 - date1);
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)); 
      return diffDays == 1? 'Today' : (diffDays + ' Days');
    },
    getTotalColumn(invoice, totalInvoice) {
      let gst = this.getGSTtotal(invoice);
      totalInvoice.paidAmount += parseFloat(invoice.paidAmount);
      totalInvoice.remainingAmount += parseFloat(invoice.remainingAmount);
      totalInvoice.totalAmount += parseFloat(invoice.totalAmount);
      totalInvoice.basicAmount += parseFloat(invoice.totalAmount) - gst;
      totalInvoice.discountAmount += parseFloat(invoice.discountAmount);
      totalInvoice.gstTotal += gst;
      totalInvoice.GST_3 += parseFloat(invoice.GST_Percentage_total.GST_3);
      totalInvoice.GST_5 += parseFloat(invoice.GST_Percentage_total.GST_5);
      totalInvoice.GST_12 += parseFloat(invoice.GST_Percentage_total.GST_12);
      totalInvoice.GST_18 += parseFloat(invoice.GST_Percentage_total.GST_18);
      totalInvoice.GST_28 += parseFloat(invoice.GST_Percentage_total.GST_28);
      return totalInvoice;
    },
    getFirmBalance(firm, type) {
      let banks = [];
      let totalBankBalance = 0;
      if (this.accounts && this.selectedBrand) {
        banks = this.accounts.filter(
          item =>
            item["brand"] === this.selectedBrand &&
            item["firm"] === firm[".key"]
        );
        banks.map(bank => {
          totalBankBalance += Number.parseFloat(bank.amount);
        });
      }
      if (type === "combined") {
        return (Number.parseFloat(firm.amount) + totalBankBalance).toFixed(2);
      } else {
        return totalBankBalance.toFixed(2);
      }
    },
    getRateByBrand() {
      let assetRateByBrand = null;
      let rateByBrand = this.assetRate.filter(
        item => item["brand"] === this.selectedBrand
      );
      if (rateByBrand && rateByBrand.length) {
        assetRateByBrand = rateByBrand[0]["rate"];
      }
      return assetRateByBrand;
    },
    calculateProfitLoss() {
      this.credited = 0.0;
      this.debited = 0.0;
      let returnAmount = 0.0;
      let returnItems = 0;
      // console.log("cal")
      // console.log(this.selectedBrand)
      // let itemCount = 0;
      this.selectedBrand && this.invoices.forEach(item => {
        if (item["brand"] === this.selectedBrand && (item.deleted != true) && (item.date >= this.finYear.start) && (item.date <= this.finYear.end)) {
          if (item["isCredited"]) {
            this.credited =
              Number.parseFloat(this.credited) +
              Number.parseFloat(item["profit"] || 0);
            returnAmount =
              Number.parseFloat(returnAmount) +
              Number.parseFloat(item["totalAmount"] || 0) -
              Number.parseFloat(item["profit"] || 0);
            returnItems =
              returnItems + (item["items"] ? item["items"].length : 0);
          }
          // item.items && item.items.forEach(item => {
          //    this.debited =
          //      Number.parseFloat(this.debited) +
          //      Number.parseFloat(item["principalValue"]);
          //      itemCount ++ ;
          // });
        }
      });
      this.items.forEach(item => {
        if (item["brand"] === this.selectedBrand) {
          this.debited =
            Number.parseFloat(this.debited) +
            Number.parseFloat(item["principalValue"]);
        }
      });
      this.credited = this.credited.toFixed(2);
      this.debited = (this.debited - returnAmount).toFixed(2);
      // this.debited = this.debited < 0 ? 0 : this.debited

      this.itemsInStock = this.getItemsCount - returnItems;
    },
    getAbsoluteValue(invoice) {
      let absoluteValue = 0;
      let assetRate = 0;
      let assetRateByBrand = this.getRateByBrand();
      if (assetRateByBrand) {
        invoice.items.map(item => {
          if (item.type === "Gold" && assetRateByBrand) {
            let rate = parseFloat(assetRateByBrand[item.type.toLowerCase()]);
            assetRate = rate !== -1 ? rate : false;
          } else if (item.type === "Silver" && assetRateByBrand) {
            let rate = parseFloat(assetRateByBrand[item.type.toLowerCase()]);
            assetRate = rate !== -1 ? rate : false;
          } else {
            assetRate = false;
          }
          let absoluteValueLocal = assetRate
            ? (assetRate * parseFloat(item.weight)) / 10
            : 0;
          absoluteValue = +absoluteValueLocal;
        });
      }
      return absoluteValue;
    },
    updateWidgets() {
      this.cards1 = [
        {
          title: "Customer",
          buyerCount: this.itemListCount,
          sellerCount: this.totalSeller,
          icon: "mdi-account"
        },
        {
          title: "Sales",
          value: this.getSalesCount,
          amount: this.totalSales - this.totalCreditNote - this.totalCreditNote,
          icon: "mdi-upload"
        },
        {
          title: "Purchase",
          value: this.getPurchaseCount,
          amount: this.totalPurchase - this.totalDebitNote - this.totalDebitNote,
          icon: "mdi-download"
        },
        {
          title: "Stock",
          measure: this.totalclosingStock,
          //aggregate: (Number.parseFloat(this.getProductOpening) + Number.parseFloat(this.totalPurchase)) - Number.parseFloat(this.totalSales),
          aggregate: this.closingStock,
          icon: "mdi-currency-usd"
        }
      ];
      this.cards2 = [
        {
          title: "Profit",
          value: "Rs. " + this.credited
        },
        {
          title: "Credit Note",
          amount: this.totalCreditNote,
          count: this.creditNoteCount
        },
        {
          title: "Debit Note",
          amount: this.totalDebitNote,
          count: this.debitNoteCount
        }
      ];
    },
    openDialog(e) {
      this.expenseDialog = true;
      this.currentExpense = e;
    },
    openDialog1(e) {
      this.incomeDialog = true;
      this.currentIncome = e;
    },
    openDialog6(e) {
      this.staffDialog = true;
      this.currentStaff = e;
    },
    openDialog7(e) {
      this.assetDialog = true;
      this.currentAsset = e;
    },
    openAccountDialog(key, accountnumber) {
      this.accountDialog = true;
      this.currentAccountNumber = accountnumber;
      this.currentAccountKey = key;
    },
    openFirmDialog(e) {
      this.firmDialog = true;
      this.currentFirm = e;
    },
    openFirstDialog(e) {
      if(e === 'Sales') {
        this.$router.push({ path: `/sale-register` });
      } else if( e === 'Purchase') {
       this.$router.push({ path: `/purchase-register` });
      } else if( e === 'Stock') {
        this.$router.push({ path: `/reports/stock` });
      } else {
         this.dialog = true;
         this.currentTitle = e;
      }
    },
    // buyerById (id) {
    //   return this.buyers[id]
    // },
    getFirmName(e) {
      let firm;
      if (this.firms && this.selectedBrand) {
        firm = this.firms.filter(item => item[".key"] === e)[0];
      }
      if (firm) return firm.name;
    },
    getGSTtotal(item) {
      let GSTTotal = 0;
      item &&
        item.items &&
        item.items.map(item => {
          GSTTotal += Number.parseFloat(item.GSTValue);
        });
      return Number.parseFloat(GSTTotal);
    },
    renderDate(timeStamp) {
      if (timeStamp) {
        return new Date(timeStamp).toLocaleDateString("en-GB");
      }
      return "--";
    },
    openProd(invoice) {
      this.selectedInvoice = invoice;
      this.dialog11 = true;
    },
    async printBasicInvoice(selectedInvoice){
      let termsAndConditions = this.getTermsAndConditions(selectedInvoice);
      if(termsAndConditions.length) {
        if(termsAndConditions[0].bank) {
        let banks = [];
        termsAndConditions[0].bank.map((bankId) =>{
          let bank = this.accounts.filter(item => item['.key'] == bankId)[0]

          bank.address = this.getAddress(bank);
          banks.push(bank);
        })
        termsAndConditions[0].banks = banks;
      } else {
          termsAndConditions[0].banks = [];
        } 
      } else {
        termsAndConditions = [{
          termsAndConditions : "",
          banks: []
        }]
      }
        let firm = this.firms.filter(item => item['.key'] == selectedInvoice.firm)[0]
        firm.address = this.getAddress(firm);
        let customer = this.getCurrentUser(selectedInvoice.buyerId)
        customer.address = this.getAddress(customer);
        // selectedInvoice['date'] = selectedInvoice['dateOfInvoice'];
          let gstInvoice = firm.GST_user && firm.GST_user == 'Yes'?  true : false;
          let gstTotal = this.calculateGSTInvoice(customer,selectedInvoice);
          let doc = gstInvoice ? await convertToBasicInvoice({
              invoiceData:selectedInvoice,
              firm:firm,
              customer : customer,
              gstTotal : gstTotal,
              terms : termsAndConditions[0]
         }): await convertToBasicInvoiceWithoutGST({
              invoiceData:selectedInvoice,
              firm:firm,
              customer : customer,
              gstTotal : gstTotal,
              terms : termsAndConditions[0]
         });
      pdfMake.createPdf(doc).download();
    },
    getTermsAndConditions(selectedInvoice){
      return this.termsAndConditions.filter(item => item["brand"] === this.selectedBrand && 
      (item['firm'] === selectedInvoice.firmID));
    },
    getAddress(item) {
      let address =
        (item.village ? item.village + " - " : "") +
        (item.block ? item.block + " - " : "") +
        (item.tehsil ? item.tehsil + " - " : "") +
        (item.district ? item.district + " - " : "") +
        (item.state ? item.state + " - " : "") +
        (item.country ? item.country + " - " : "");
      address = address.substring(0, address.length - 2);
      return address;
    },
    calculateGSTInvoice(currentUser, invoice) {
      let SGST_val = 0;
      let CGST_val = 0;
      let IGST_val = 0;
      invoice.items && invoice.items.map((item, index) => {
        SGST_val += parseFloat(item["SGST_val"]);
        CGST_val += parseFloat(item["CGST_val"]);
        IGST_val += parseFloat(item["IGST_val"]);
      });
      return { SGST_val, CGST_val, IGST_val };
    },
    getCurrentUserName(buyerId) {
      let buyer = this.buyerById[buyerId];
      let seller = this.sellerById[buyerId];
      let currentUser =
      buyer ? buyer : seller  ? seller : {};
      return currentUser ? currentUser.name : '';
    },
    getStaffName(staff){
      return this.staffs.filter(item => item[".key"] === staff)[0].staffName;
    },
    getCurrentUser(buyerId) {
      let buyer = this.buyerById[buyerId];
      let seller = this.sellerById[buyerId];
      let currentUser =
      buyer ? buyer : seller  ? seller : {};
      return currentUser;
    },
    getVocherType(invoice) {
      if(invoice.brokrageInvoice) {
        return 'Brokrage'
      }
      if (invoice.return) {
        if (invoice.isBuyer) {
          return "Credit Note";
        } else {
          return "Debit Note";
        }
      }
      if (invoice["type"] == "automatic invoice" && invoice.assetType) {
        return "asset";
      }
      if (invoice["type"] == "automatic invoice" && invoice.expenseType) {
        return "expense";
      }
      if (invoice["type"] == "automatic invoice" && invoice.liabilityType) {
        return "liability";
      }
      if (invoice["type"] == "automatic invoice" && invoice.incomeType) {
        return "income";
      }
      if (invoice["type"] == "automatic invoice" && invoice.staffType) {
        return "Staff";
      }
      if (
        invoice["type"] == "automatic invoice" &&
        invoice.transactionType === "Transfer"
      ) {
        return "Transfer";
      } 
      else if (
        (invoice.transactionType != "Debit" && invoice["type"] === "Advance") ||
        invoice["type"] === "Opening Balance" ||
        invoice["type"] === "LoanGiven" || 
        invoice["type"] === "LoanTaken" ||
        invoice["type"] === "Security"
      ) {
        return invoice["type"];
      } 
      else if (invoice.isBuyer && invoice.transactionType === "Debit") {
        return "Sale";
      } 
      else if (invoice.isBuyer && invoice.transactionType === "Credit") {
        return "Receipt";
      }
      else if (invoice.isBuyer && invoice.transactionType === "Partial Paid") {
        return "Receipt";
      }
      else if (!invoice.isBuyer && invoice.transactionType === "Debit") {
        return "Purchase";
      }
      else if (!invoice.isBuyer && invoice.transactionType === "Credit") {
        return "Payment";
      }
      else if (!invoice.isBuyer && invoice.transactionType === "Partial Paid") {
        return "Payment";
      }

      // else if (
      //   (invoice.isBuyer && invoice.transactionType === "Credit") ||
      //   (!invoice.isBuyer && invoice.transactionType === "Credit")
      // ) {
      //   return "Payment";
      // }

      // else if (
      //   (invoice.isBuyer && invoice.transactionType === "Partial Paid") ||
      //   (!invoice.isBuyer && invoice.transactionType === "Partial Paid")
      // ) {
      //   return "Partial Paid";
      // } else if (!invoice.isBuyer && invoice.transactionType === "Debit") {
      //   return "Purchase";
      // }
    }
  }
};
</script>

<style scoped>
.card__text.number {
  font-size: xx-large;
  font-weight: bolder;
}

.one-dashboard .sec1-card {
  background-color: #ffffff !important;
  border-color: #ffffff !important;
  color: #15155d !important;
  font-weight: bold;
  font-size: 14px;
  padding: 10px;
}

.one-dashboard .headline {
  font-weight: bold;
  margin-left: 70px;
}

.one-dashboard .v-card__title--primary {
  padding: 5px;
}

.one-dashboard .icon-card {
  width: 60px;
  height: 60px;
  z-index: 2;
  top: 30px;
  background: #15155d;
  left: 10px;
}

.one-dashboard .icon-card i {
  padding: 12px;
  color: white;
}

.one-dashboard .sec3-card {
  position: relative;
  bottom: 8px;
  margin-bottom: 9px;
  font-size: 15px;
  text-align: left;
  padding-left: 9px;
  color: #15155d;
  font-weight: bold;
}
</style>

<style>
 .theme--light div.select-firm-dashboard .v-icon {
  color: #15155d;
}
 .theme--light div.select-firm-dashboard .v-label {
  color: #15155d;
}

.theme--light .filter-switch {
  position: absolute;
  right: 20px;
  margin-top: 10px;
}

.theme--light .filter-switch .v-label {
  color: white;
}

.theme--light .v-label {
    color: #15155d;
}

.theme--light.v-input--switch__track {
    color: rgba(255, 255, 255, 0.38);
}
div.select-firm-dashboard .v-input__slot:before {
  border-color: #15155d !important;
}
div.select-firm-dashboard .v-select__selection--comma {
  color: #15155d;
}

.ist-datepicker-dashboard .v-icon,
.ist-datepicker-dashboard .v-label,
.ist-datepicker-dashboard input {
  color: #15155d !important;
 }

.ist-datepicker-dashboard .v-input__slot:before {
  border-color: #15155d !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/index.vue